var map = {
	"./": [
		3778,
		9,
		3778
	],
	"./_lib/buildFormatLongFn": [
		79132,
		7,
		79132
	],
	"./_lib/buildFormatLongFn/": [
		79132,
		7,
		79132
	],
	"./_lib/buildFormatLongFn/index": [
		79132,
		7,
		79132
	],
	"./_lib/buildFormatLongFn/index.js": [
		79132,
		7,
		79132
	],
	"./_lib/buildLocalizeFn": [
		6313,
		7,
		6313
	],
	"./_lib/buildLocalizeFn/": [
		6313,
		7,
		6313
	],
	"./_lib/buildLocalizeFn/index": [
		6313,
		7,
		6313
	],
	"./_lib/buildLocalizeFn/index.js": [
		6313,
		7,
		6313
	],
	"./_lib/buildMatchFn": [
		55113,
		7,
		55113
	],
	"./_lib/buildMatchFn/": [
		55113,
		7,
		55113
	],
	"./_lib/buildMatchFn/index": [
		55113,
		7,
		55113
	],
	"./_lib/buildMatchFn/index.js": [
		55113,
		7,
		55113
	],
	"./_lib/buildMatchPatternFn": [
		47043,
		7,
		47043
	],
	"./_lib/buildMatchPatternFn/": [
		47043,
		7,
		47043
	],
	"./_lib/buildMatchPatternFn/index": [
		47043,
		7,
		47043
	],
	"./_lib/buildMatchPatternFn/index.js": [
		47043,
		7,
		47043
	],
	"./af": [
		36131,
		9,
		52583
	],
	"./af/": [
		36131,
		9,
		52583
	],
	"./af/_lib/formatDistance": [
		26772,
		7,
		26772
	],
	"./af/_lib/formatDistance/": [
		26772,
		7,
		26772
	],
	"./af/_lib/formatDistance/index": [
		26772,
		7,
		26772
	],
	"./af/_lib/formatDistance/index.js": [
		26772,
		7,
		26772
	],
	"./af/_lib/formatLong": [
		57764,
		7,
		57764
	],
	"./af/_lib/formatLong/": [
		57764,
		7,
		57764
	],
	"./af/_lib/formatLong/index": [
		57764,
		7,
		57764
	],
	"./af/_lib/formatLong/index.js": [
		57764,
		7,
		57764
	],
	"./af/_lib/formatRelative": [
		53197,
		7,
		53197
	],
	"./af/_lib/formatRelative/": [
		53197,
		7,
		53197
	],
	"./af/_lib/formatRelative/index": [
		53197,
		7,
		53197
	],
	"./af/_lib/formatRelative/index.js": [
		53197,
		7,
		53197
	],
	"./af/_lib/localize": [
		85954,
		7,
		85954
	],
	"./af/_lib/localize/": [
		85954,
		7,
		85954
	],
	"./af/_lib/localize/index": [
		85954,
		7,
		85954
	],
	"./af/_lib/localize/index.js": [
		85954,
		7,
		85954
	],
	"./af/_lib/match": [
		81914,
		7,
		81914
	],
	"./af/_lib/match/": [
		81914,
		7,
		81914
	],
	"./af/_lib/match/index": [
		81914,
		7,
		81914
	],
	"./af/_lib/match/index.js": [
		81914,
		7,
		81914
	],
	"./af/index": [
		76501,
		7,
		76501
	],
	"./af/index.d": [
		52583,
		9,
		52583
	],
	"./af/index.d.ts": [
		52583,
		9,
		52583
	],
	"./af/index.js": [
		76501,
		7,
		76501
	],
	"./af/index.js.flow": [
		476,
		7,
		476
	],
	"./af/package": [
		30877,
		3,
		30877
	],
	"./af/package.json": [
		30877,
		3,
		30877
	],
	"./af/snapshot.md": [
		37132,
		7,
		37132
	],
	"./ar-DZ": [
		95937,
		9,
		51267
	],
	"./ar-DZ/": [
		95937,
		9,
		51267
	],
	"./ar-DZ/_lib/formatDistance": [
		39691,
		7,
		39691
	],
	"./ar-DZ/_lib/formatDistance/": [
		39691,
		7,
		39691
	],
	"./ar-DZ/_lib/formatDistance/index": [
		39691,
		7,
		39691
	],
	"./ar-DZ/_lib/formatDistance/index.js": [
		39691,
		7,
		39691
	],
	"./ar-DZ/_lib/formatLong": [
		95521,
		7,
		95521
	],
	"./ar-DZ/_lib/formatLong/": [
		95521,
		7,
		95521
	],
	"./ar-DZ/_lib/formatLong/index": [
		95521,
		7,
		95521
	],
	"./ar-DZ/_lib/formatLong/index.js": [
		95521,
		7,
		95521
	],
	"./ar-DZ/_lib/formatRelative": [
		83168,
		7,
		83168
	],
	"./ar-DZ/_lib/formatRelative/": [
		83168,
		7,
		83168
	],
	"./ar-DZ/_lib/formatRelative/index": [
		83168,
		7,
		83168
	],
	"./ar-DZ/_lib/formatRelative/index.js": [
		83168,
		7,
		83168
	],
	"./ar-DZ/_lib/localize": [
		17918,
		7,
		17918
	],
	"./ar-DZ/_lib/localize/": [
		17918,
		7,
		17918
	],
	"./ar-DZ/_lib/localize/index": [
		17918,
		7,
		17918
	],
	"./ar-DZ/_lib/localize/index.js": [
		17918,
		7,
		17918
	],
	"./ar-DZ/_lib/match": [
		2474,
		7,
		2474
	],
	"./ar-DZ/_lib/match/": [
		2474,
		7,
		2474
	],
	"./ar-DZ/_lib/match/index": [
		2474,
		7,
		2474
	],
	"./ar-DZ/_lib/match/index.js": [
		2474,
		7,
		2474
	],
	"./ar-DZ/index": [
		69999,
		7,
		69999
	],
	"./ar-DZ/index.d": [
		51267,
		9,
		51267
	],
	"./ar-DZ/index.d.ts": [
		51267,
		9,
		51267
	],
	"./ar-DZ/index.js": [
		69999,
		7,
		69999
	],
	"./ar-DZ/index.js.flow": [
		9627,
		7,
		9627
	],
	"./ar-DZ/package": [
		51194,
		3,
		51194
	],
	"./ar-DZ/package.json": [
		51194,
		3,
		51194
	],
	"./ar-DZ/snapshot.md": [
		6234,
		7,
		6234
	],
	"./ar-MA": [
		67651,
		9,
		71026
	],
	"./ar-MA/": [
		67651,
		9,
		71026
	],
	"./ar-MA/_lib/formatDistance": [
		24161,
		7,
		24161
	],
	"./ar-MA/_lib/formatDistance/": [
		24161,
		7,
		24161
	],
	"./ar-MA/_lib/formatDistance/index": [
		24161,
		7,
		24161
	],
	"./ar-MA/_lib/formatDistance/index.js": [
		24161,
		7,
		24161
	],
	"./ar-MA/_lib/formatLong": [
		58579,
		7,
		58579
	],
	"./ar-MA/_lib/formatLong/": [
		58579,
		7,
		58579
	],
	"./ar-MA/_lib/formatLong/index": [
		58579,
		7,
		58579
	],
	"./ar-MA/_lib/formatLong/index.js": [
		58579,
		7,
		58579
	],
	"./ar-MA/_lib/formatRelative": [
		96545,
		7,
		96545
	],
	"./ar-MA/_lib/formatRelative/": [
		96545,
		7,
		96545
	],
	"./ar-MA/_lib/formatRelative/index": [
		96545,
		7,
		96545
	],
	"./ar-MA/_lib/formatRelative/index.js": [
		96545,
		7,
		96545
	],
	"./ar-MA/_lib/localize": [
		39440,
		7,
		39440
	],
	"./ar-MA/_lib/localize/": [
		39440,
		7,
		39440
	],
	"./ar-MA/_lib/localize/index": [
		39440,
		7,
		39440
	],
	"./ar-MA/_lib/localize/index.js": [
		39440,
		7,
		39440
	],
	"./ar-MA/_lib/match": [
		10616,
		7,
		10616
	],
	"./ar-MA/_lib/match/": [
		10616,
		7,
		10616
	],
	"./ar-MA/_lib/match/index": [
		10616,
		7,
		10616
	],
	"./ar-MA/_lib/match/index.js": [
		10616,
		7,
		10616
	],
	"./ar-MA/index": [
		1323,
		7,
		1323
	],
	"./ar-MA/index.d": [
		71026,
		9,
		71026
	],
	"./ar-MA/index.d.ts": [
		71026,
		9,
		71026
	],
	"./ar-MA/index.js": [
		1323,
		7,
		1323
	],
	"./ar-MA/index.js.flow": [
		39060,
		7,
		39060
	],
	"./ar-MA/package": [
		44854,
		3,
		44854
	],
	"./ar-MA/package.json": [
		44854,
		3,
		44854
	],
	"./ar-MA/snapshot.md": [
		73295,
		7,
		73295
	],
	"./ar-SA": [
		71260,
		9,
		35896
	],
	"./ar-SA/": [
		71260,
		9,
		35896
	],
	"./ar-SA/_lib/formatDistance": [
		74739,
		7,
		74739
	],
	"./ar-SA/_lib/formatDistance/": [
		74739,
		7,
		74739
	],
	"./ar-SA/_lib/formatDistance/index": [
		74739,
		7,
		74739
	],
	"./ar-SA/_lib/formatDistance/index.js": [
		74739,
		7,
		74739
	],
	"./ar-SA/_lib/formatLong": [
		89648,
		7,
		89648
	],
	"./ar-SA/_lib/formatLong/": [
		89648,
		7,
		89648
	],
	"./ar-SA/_lib/formatLong/index": [
		89648,
		7,
		89648
	],
	"./ar-SA/_lib/formatLong/index.js": [
		89648,
		7,
		89648
	],
	"./ar-SA/_lib/formatRelative": [
		15666,
		7,
		15666
	],
	"./ar-SA/_lib/formatRelative/": [
		15666,
		7,
		15666
	],
	"./ar-SA/_lib/formatRelative/index": [
		15666,
		7,
		15666
	],
	"./ar-SA/_lib/formatRelative/index.js": [
		15666,
		7,
		15666
	],
	"./ar-SA/_lib/localize": [
		85569,
		7,
		85569
	],
	"./ar-SA/_lib/localize/": [
		85569,
		7,
		85569
	],
	"./ar-SA/_lib/localize/index": [
		85569,
		7,
		85569
	],
	"./ar-SA/_lib/localize/index.js": [
		85569,
		7,
		85569
	],
	"./ar-SA/_lib/match": [
		77595,
		7,
		77595
	],
	"./ar-SA/_lib/match/": [
		77595,
		7,
		77595
	],
	"./ar-SA/_lib/match/index": [
		77595,
		7,
		77595
	],
	"./ar-SA/_lib/match/index.js": [
		77595,
		7,
		77595
	],
	"./ar-SA/index": [
		49871,
		7,
		49871
	],
	"./ar-SA/index.d": [
		35896,
		9,
		35896
	],
	"./ar-SA/index.d.ts": [
		35896,
		9,
		35896
	],
	"./ar-SA/index.js": [
		49871,
		7,
		49871
	],
	"./ar-SA/index.js.flow": [
		39394,
		7,
		39394
	],
	"./ar-SA/package": [
		9036,
		3,
		9036
	],
	"./ar-SA/package.json": [
		9036,
		3,
		9036
	],
	"./ar-SA/snapshot.md": [
		75703,
		7,
		75703
	],
	"./az": [
		67512,
		9,
		37210
	],
	"./az/": [
		67512,
		9,
		37210
	],
	"./az/_lib/formatDistance": [
		53273,
		7,
		53273
	],
	"./az/_lib/formatDistance/": [
		53273,
		7,
		53273
	],
	"./az/_lib/formatDistance/index": [
		53273,
		7,
		53273
	],
	"./az/_lib/formatDistance/index.js": [
		53273,
		7,
		53273
	],
	"./az/_lib/formatLong": [
		43152,
		7,
		46915
	],
	"./az/_lib/formatLong/": [
		43152,
		7,
		46915
	],
	"./az/_lib/formatLong/index": [
		43152,
		7,
		46915
	],
	"./az/_lib/formatLong/index.js": [
		43152,
		7,
		46915
	],
	"./az/_lib/formatRelative": [
		41914,
		7,
		41914
	],
	"./az/_lib/formatRelative/": [
		41914,
		7,
		41914
	],
	"./az/_lib/formatRelative/index": [
		41914,
		7,
		41914
	],
	"./az/_lib/formatRelative/index.js": [
		41914,
		7,
		41914
	],
	"./az/_lib/localize": [
		88307,
		7,
		88307
	],
	"./az/_lib/localize/": [
		88307,
		7,
		88307
	],
	"./az/_lib/localize/index": [
		88307,
		7,
		88307
	],
	"./az/_lib/localize/index.js": [
		88307,
		7,
		88307
	],
	"./az/_lib/match": [
		28400,
		7,
		28400
	],
	"./az/_lib/match/": [
		28400,
		7,
		28400
	],
	"./az/_lib/match/index": [
		28400,
		7,
		28400
	],
	"./az/_lib/match/index.js": [
		28400,
		7,
		28400
	],
	"./az/index": [
		59831,
		7,
		59831
	],
	"./az/index.d": [
		37210,
		9,
		37210
	],
	"./az/index.d.ts": [
		37210,
		9,
		37210
	],
	"./az/index.js": [
		59831,
		7,
		59831
	],
	"./az/index.js.flow": [
		17135,
		7,
		17135
	],
	"./az/package": [
		4586,
		3,
		4586
	],
	"./az/package.json": [
		4586,
		3,
		4586
	],
	"./az/snapshot.md": [
		6606,
		7,
		75904
	],
	"./be": [
		33845,
		9,
		73120
	],
	"./be/": [
		33845,
		9,
		73120
	],
	"./be/_lib/formatDistance": [
		34117,
		7,
		34117
	],
	"./be/_lib/formatDistance/": [
		34117,
		7,
		34117
	],
	"./be/_lib/formatDistance/index": [
		34117,
		7,
		34117
	],
	"./be/_lib/formatDistance/index.js": [
		34117,
		7,
		34117
	],
	"./be/_lib/formatLong": [
		40814,
		7,
		40814
	],
	"./be/_lib/formatLong/": [
		40814,
		7,
		40814
	],
	"./be/_lib/formatLong/index": [
		40814,
		7,
		40814
	],
	"./be/_lib/formatLong/index.js": [
		40814,
		7,
		40814
	],
	"./be/_lib/formatRelative": [
		24922,
		7,
		23162
	],
	"./be/_lib/formatRelative/": [
		24922,
		7,
		23162
	],
	"./be/_lib/formatRelative/index": [
		24922,
		7,
		23162
	],
	"./be/_lib/formatRelative/index.js": [
		24922,
		7,
		23162
	],
	"./be/_lib/localize": [
		59782,
		7,
		59782
	],
	"./be/_lib/localize/": [
		59782,
		7,
		59782
	],
	"./be/_lib/localize/index": [
		59782,
		7,
		59782
	],
	"./be/_lib/localize/index.js": [
		59782,
		7,
		59782
	],
	"./be/_lib/match": [
		65813,
		7,
		65813
	],
	"./be/_lib/match/": [
		65813,
		7,
		65813
	],
	"./be/_lib/match/index": [
		65813,
		7,
		65813
	],
	"./be/_lib/match/index.js": [
		65813,
		7,
		65813
	],
	"./be/index": [
		10387,
		7,
		10387
	],
	"./be/index.d": [
		73120,
		9,
		73120
	],
	"./be/index.d.ts": [
		73120,
		9,
		73120
	],
	"./be/index.js": [
		10387,
		7,
		10387
	],
	"./be/index.js.flow": [
		18494,
		7,
		18494
	],
	"./be/package": [
		45039,
		3,
		45039
	],
	"./be/package.json": [
		45039,
		3,
		45039
	],
	"./be/snapshot.md": [
		28193,
		7,
		28193
	],
	"./bg": [
		16029,
		9,
		4494
	],
	"./bg/": [
		16029,
		9,
		4494
	],
	"./bg/_lib/formatDistance": [
		31226,
		7,
		31226
	],
	"./bg/_lib/formatDistance/": [
		31226,
		7,
		31226
	],
	"./bg/_lib/formatDistance/index": [
		31226,
		7,
		31226
	],
	"./bg/_lib/formatDistance/index.js": [
		31226,
		7,
		31226
	],
	"./bg/_lib/formatLong": [
		47033,
		7,
		47033
	],
	"./bg/_lib/formatLong/": [
		47033,
		7,
		47033
	],
	"./bg/_lib/formatLong/index": [
		47033,
		7,
		47033
	],
	"./bg/_lib/formatLong/index.js": [
		47033,
		7,
		47033
	],
	"./bg/_lib/formatRelative": [
		24595,
		7,
		8669
	],
	"./bg/_lib/formatRelative/": [
		24595,
		7,
		8669
	],
	"./bg/_lib/formatRelative/index": [
		24595,
		7,
		8669
	],
	"./bg/_lib/formatRelative/index.js": [
		24595,
		7,
		8669
	],
	"./bg/_lib/localize": [
		34959,
		7,
		34959
	],
	"./bg/_lib/localize/": [
		34959,
		7,
		34959
	],
	"./bg/_lib/localize/index": [
		34959,
		7,
		34959
	],
	"./bg/_lib/localize/index.js": [
		34959,
		7,
		34959
	],
	"./bg/_lib/match": [
		41791,
		7,
		41791
	],
	"./bg/_lib/match/": [
		41791,
		7,
		41791
	],
	"./bg/_lib/match/index": [
		41791,
		7,
		41791
	],
	"./bg/_lib/match/index.js": [
		41791,
		7,
		41791
	],
	"./bg/index": [
		18743,
		7,
		18743
	],
	"./bg/index.d": [
		4494,
		9,
		4494
	],
	"./bg/index.d.ts": [
		4494,
		9,
		4494
	],
	"./bg/index.js": [
		18743,
		7,
		18743
	],
	"./bg/index.js.flow": [
		57748,
		7,
		57748
	],
	"./bg/package": [
		59878,
		3,
		59878
	],
	"./bg/package.json": [
		59878,
		3,
		59878
	],
	"./bg/snapshot.md": [
		66886,
		7,
		66886
	],
	"./bn": [
		8394,
		9,
		33482
	],
	"./bn/": [
		8394,
		9,
		33482
	],
	"./bn/_lib/formatDistance": [
		60614,
		7,
		60614
	],
	"./bn/_lib/formatDistance/": [
		60614,
		7,
		60614
	],
	"./bn/_lib/formatDistance/index": [
		60614,
		7,
		60614
	],
	"./bn/_lib/formatDistance/index.js": [
		60614,
		7,
		60614
	],
	"./bn/_lib/formatLong": [
		50148,
		7,
		50148
	],
	"./bn/_lib/formatLong/": [
		50148,
		7,
		50148
	],
	"./bn/_lib/formatLong/index": [
		50148,
		7,
		50148
	],
	"./bn/_lib/formatLong/index.js": [
		50148,
		7,
		50148
	],
	"./bn/_lib/formatRelative": [
		37753,
		7,
		37753
	],
	"./bn/_lib/formatRelative/": [
		37753,
		7,
		37753
	],
	"./bn/_lib/formatRelative/index": [
		37753,
		7,
		37753
	],
	"./bn/_lib/formatRelative/index.js": [
		37753,
		7,
		37753
	],
	"./bn/_lib/localize": [
		27754,
		7,
		60614
	],
	"./bn/_lib/localize/": [
		27754,
		7,
		60614
	],
	"./bn/_lib/localize/index": [
		27754,
		7,
		60614
	],
	"./bn/_lib/localize/index.js": [
		27754,
		7,
		60614
	],
	"./bn/_lib/match": [
		67319,
		7,
		67319
	],
	"./bn/_lib/match/": [
		67319,
		7,
		67319
	],
	"./bn/_lib/match/index": [
		67319,
		7,
		67319
	],
	"./bn/_lib/match/index.js": [
		67319,
		7,
		67319
	],
	"./bn/index": [
		44221,
		7,
		44221
	],
	"./bn/index.d": [
		33482,
		9,
		33482
	],
	"./bn/index.d.ts": [
		33482,
		9,
		33482
	],
	"./bn/index.js": [
		44221,
		7,
		44221
	],
	"./bn/index.js.flow": [
		17457,
		7,
		17457
	],
	"./bn/package": [
		22020,
		3,
		22020
	],
	"./bn/package.json": [
		22020,
		3,
		22020
	],
	"./bn/snapshot.md": [
		13719,
		7,
		13719
	],
	"./ca": [
		47837,
		9,
		27125
	],
	"./ca/": [
		47837,
		9,
		27125
	],
	"./ca/_lib/formatDistance": [
		41365,
		7,
		41365
	],
	"./ca/_lib/formatDistance/": [
		41365,
		7,
		41365
	],
	"./ca/_lib/formatDistance/index": [
		41365,
		7,
		41365
	],
	"./ca/_lib/formatDistance/index.js": [
		41365,
		7,
		41365
	],
	"./ca/_lib/formatLong": [
		97682,
		7,
		97682
	],
	"./ca/_lib/formatLong/": [
		97682,
		7,
		97682
	],
	"./ca/_lib/formatLong/index": [
		97682,
		7,
		97682
	],
	"./ca/_lib/formatLong/index.js": [
		97682,
		7,
		97682
	],
	"./ca/_lib/formatRelative": [
		26014,
		7,
		26014
	],
	"./ca/_lib/formatRelative/": [
		26014,
		7,
		26014
	],
	"./ca/_lib/formatRelative/index": [
		26014,
		7,
		26014
	],
	"./ca/_lib/formatRelative/index.js": [
		26014,
		7,
		26014
	],
	"./ca/_lib/localize": [
		40623,
		7,
		40623
	],
	"./ca/_lib/localize/": [
		40623,
		7,
		40623
	],
	"./ca/_lib/localize/index": [
		40623,
		7,
		40623
	],
	"./ca/_lib/localize/index.js": [
		40623,
		7,
		40623
	],
	"./ca/_lib/match": [
		98044,
		7,
		98044
	],
	"./ca/_lib/match/": [
		98044,
		7,
		98044
	],
	"./ca/_lib/match/index": [
		98044,
		7,
		98044
	],
	"./ca/_lib/match/index.js": [
		98044,
		7,
		98044
	],
	"./ca/index": [
		6727,
		7,
		6727
	],
	"./ca/index.d": [
		27125,
		9,
		27125
	],
	"./ca/index.d.ts": [
		27125,
		9,
		27125
	],
	"./ca/index.js": [
		6727,
		7,
		6727
	],
	"./ca/index.js.flow": [
		90091,
		7,
		26522
	],
	"./ca/package": [
		54479,
		3,
		54479
	],
	"./ca/package.json": [
		54479,
		3,
		54479
	],
	"./ca/snapshot.md": [
		95755,
		7,
		95755
	],
	"./cs": [
		94076,
		9,
		5637
	],
	"./cs/": [
		94076,
		9,
		5637
	],
	"./cs/_lib/formatDistance": [
		77235,
		7,
		77235
	],
	"./cs/_lib/formatDistance/": [
		77235,
		7,
		77235
	],
	"./cs/_lib/formatDistance/index": [
		77235,
		7,
		77235
	],
	"./cs/_lib/formatDistance/index.js": [
		77235,
		7,
		77235
	],
	"./cs/_lib/formatLong": [
		31191,
		7,
		31191
	],
	"./cs/_lib/formatLong/": [
		31191,
		7,
		31191
	],
	"./cs/_lib/formatLong/index": [
		31191,
		7,
		31191
	],
	"./cs/_lib/formatLong/index.js": [
		31191,
		7,
		31191
	],
	"./cs/_lib/formatRelative": [
		57607,
		7,
		57607
	],
	"./cs/_lib/formatRelative/": [
		57607,
		7,
		57607
	],
	"./cs/_lib/formatRelative/index": [
		57607,
		7,
		57607
	],
	"./cs/_lib/formatRelative/index.js": [
		57607,
		7,
		57607
	],
	"./cs/_lib/localize": [
		80800,
		7,
		80800
	],
	"./cs/_lib/localize/": [
		80800,
		7,
		80800
	],
	"./cs/_lib/localize/index": [
		80800,
		7,
		80800
	],
	"./cs/_lib/localize/index.js": [
		80800,
		7,
		80800
	],
	"./cs/_lib/match": [
		53959,
		7,
		53959
	],
	"./cs/_lib/match/": [
		53959,
		7,
		53959
	],
	"./cs/_lib/match/index": [
		53959,
		7,
		53959
	],
	"./cs/_lib/match/index.js": [
		53959,
		7,
		53959
	],
	"./cs/index": [
		37739,
		7,
		37739
	],
	"./cs/index.d": [
		5637,
		9,
		5637
	],
	"./cs/index.d.ts": [
		5637,
		9,
		5637
	],
	"./cs/index.js": [
		37739,
		7,
		37739
	],
	"./cs/index.js.flow": [
		61546,
		7,
		61546
	],
	"./cs/package": [
		53939,
		3,
		53939
	],
	"./cs/package.json": [
		53939,
		3,
		53939
	],
	"./cs/snapshot.md": [
		51995,
		7,
		51995
	],
	"./cy": [
		52771,
		9,
		37767
	],
	"./cy/": [
		52771,
		9,
		37767
	],
	"./cy/_lib/formatDistance": [
		81565,
		7,
		81565
	],
	"./cy/_lib/formatDistance/": [
		81565,
		7,
		81565
	],
	"./cy/_lib/formatDistance/index": [
		81565,
		7,
		81565
	],
	"./cy/_lib/formatDistance/index.js": [
		81565,
		7,
		81565
	],
	"./cy/_lib/formatLong": [
		32172,
		7,
		32172
	],
	"./cy/_lib/formatLong/": [
		32172,
		7,
		32172
	],
	"./cy/_lib/formatLong/index": [
		32172,
		7,
		32172
	],
	"./cy/_lib/formatLong/index.js": [
		32172,
		7,
		32172
	],
	"./cy/_lib/formatRelative": [
		4557,
		7,
		4557
	],
	"./cy/_lib/formatRelative/": [
		4557,
		7,
		4557
	],
	"./cy/_lib/formatRelative/index": [
		4557,
		7,
		4557
	],
	"./cy/_lib/formatRelative/index.js": [
		4557,
		7,
		4557
	],
	"./cy/_lib/localize": [
		95161,
		7,
		95161
	],
	"./cy/_lib/localize/": [
		95161,
		7,
		95161
	],
	"./cy/_lib/localize/index": [
		95161,
		7,
		95161
	],
	"./cy/_lib/localize/index.js": [
		95161,
		7,
		95161
	],
	"./cy/_lib/match": [
		47348,
		7,
		47348
	],
	"./cy/_lib/match/": [
		47348,
		7,
		47348
	],
	"./cy/_lib/match/index": [
		47348,
		7,
		47348
	],
	"./cy/_lib/match/index.js": [
		47348,
		7,
		47348
	],
	"./cy/index": [
		15015,
		7,
		15015
	],
	"./cy/index.d": [
		37767,
		9,
		37767
	],
	"./cy/index.d.ts": [
		37767,
		9,
		37767
	],
	"./cy/index.js": [
		15015,
		7,
		15015
	],
	"./cy/index.js.flow": [
		62944,
		7,
		62944
	],
	"./cy/package": [
		82939,
		3,
		82939
	],
	"./cy/package.json": [
		82939,
		3,
		82939
	],
	"./cy/snapshot.md": [
		5260,
		7,
		5260
	],
	"./da": [
		99888,
		9,
		87602
	],
	"./da/": [
		99888,
		9,
		87602
	],
	"./da/_lib/formatDistance": [
		43365,
		7,
		43365
	],
	"./da/_lib/formatDistance/": [
		43365,
		7,
		43365
	],
	"./da/_lib/formatDistance/index": [
		43365,
		7,
		43365
	],
	"./da/_lib/formatDistance/index.js": [
		43365,
		7,
		43365
	],
	"./da/_lib/formatLong": [
		8259,
		7,
		8259
	],
	"./da/_lib/formatLong/": [
		8259,
		7,
		8259
	],
	"./da/_lib/formatLong/index": [
		8259,
		7,
		8259
	],
	"./da/_lib/formatLong/index.js": [
		8259,
		7,
		8259
	],
	"./da/_lib/formatRelative": [
		67381,
		7,
		67381
	],
	"./da/_lib/formatRelative/": [
		67381,
		7,
		67381
	],
	"./da/_lib/formatRelative/index": [
		67381,
		7,
		67381
	],
	"./da/_lib/formatRelative/index.js": [
		67381,
		7,
		67381
	],
	"./da/_lib/localize": [
		83940,
		7,
		83940
	],
	"./da/_lib/localize/": [
		83940,
		7,
		83940
	],
	"./da/_lib/localize/index": [
		83940,
		7,
		83940
	],
	"./da/_lib/localize/index.js": [
		83940,
		7,
		83940
	],
	"./da/_lib/match": [
		16481,
		7,
		16481
	],
	"./da/_lib/match/": [
		16481,
		7,
		16481
	],
	"./da/_lib/match/index": [
		16481,
		7,
		16481
	],
	"./da/_lib/match/index.js": [
		16481,
		7,
		16481
	],
	"./da/index": [
		76499,
		7,
		76499
	],
	"./da/index.d": [
		87602,
		9,
		87602
	],
	"./da/index.d.ts": [
		87602,
		9,
		87602
	],
	"./da/index.js": [
		76499,
		7,
		76499
	],
	"./da/index.js.flow": [
		36911,
		7,
		36911
	],
	"./da/package": [
		58420,
		3,
		58420
	],
	"./da/package.json": [
		58420,
		3,
		58420
	],
	"./da/snapshot.md": [
		23249,
		7,
		23249
	],
	"./de": [
		171,
		9,
		64092
	],
	"./de/": [
		171,
		9,
		64092
	],
	"./de/_lib/formatDistance": [
		7043,
		7,
		7043
	],
	"./de/_lib/formatDistance/": [
		7043,
		7,
		7043
	],
	"./de/_lib/formatDistance/index": [
		7043,
		7,
		7043
	],
	"./de/_lib/formatDistance/index.js": [
		7043,
		7,
		7043
	],
	"./de/_lib/formatLong": [
		37951,
		7,
		37951
	],
	"./de/_lib/formatLong/": [
		37951,
		7,
		37951
	],
	"./de/_lib/formatLong/index": [
		37951,
		7,
		37951
	],
	"./de/_lib/formatLong/index.js": [
		37951,
		7,
		37951
	],
	"./de/_lib/formatRelative": [
		55412,
		7,
		55412
	],
	"./de/_lib/formatRelative/": [
		55412,
		7,
		55412
	],
	"./de/_lib/formatRelative/index": [
		55412,
		7,
		55412
	],
	"./de/_lib/formatRelative/index.js": [
		55412,
		7,
		55412
	],
	"./de/_lib/localize": [
		24538,
		7,
		24538
	],
	"./de/_lib/localize/": [
		24538,
		7,
		24538
	],
	"./de/_lib/localize/index": [
		24538,
		7,
		24538
	],
	"./de/_lib/localize/index.js": [
		24538,
		7,
		24538
	],
	"./de/_lib/match": [
		46337,
		7,
		46337
	],
	"./de/_lib/match/": [
		46337,
		7,
		46337
	],
	"./de/_lib/match/index": [
		46337,
		7,
		46337
	],
	"./de/_lib/match/index.js": [
		46337,
		7,
		46337
	],
	"./de/index": [
		25192,
		7,
		25192
	],
	"./de/index.d": [
		64092,
		9,
		64092
	],
	"./de/index.d.ts": [
		64092,
		9,
		64092
	],
	"./de/index.js": [
		25192,
		7,
		25192
	],
	"./de/index.js.flow": [
		14388,
		7,
		14388
	],
	"./de/package": [
		56922,
		3,
		56922
	],
	"./de/package.json": [
		56922,
		3,
		56922
	],
	"./de/snapshot.md": [
		19351,
		7,
		19351
	],
	"./el": [
		73312,
		9,
		61584
	],
	"./el/": [
		73312,
		9,
		61584
	],
	"./el/_lib/formatDistance": [
		42008,
		7,
		42008
	],
	"./el/_lib/formatDistance/": [
		42008,
		7,
		42008
	],
	"./el/_lib/formatDistance/index": [
		42008,
		7,
		42008
	],
	"./el/_lib/formatDistance/index.js": [
		42008,
		7,
		42008
	],
	"./el/_lib/formatLong": [
		85062,
		7,
		85062
	],
	"./el/_lib/formatLong/": [
		85062,
		7,
		85062
	],
	"./el/_lib/formatLong/index": [
		85062,
		7,
		85062
	],
	"./el/_lib/formatLong/index.js": [
		85062,
		7,
		85062
	],
	"./el/_lib/formatRelative": [
		9141,
		7,
		9141
	],
	"./el/_lib/formatRelative/": [
		9141,
		7,
		9141
	],
	"./el/_lib/formatRelative/index": [
		9141,
		7,
		9141
	],
	"./el/_lib/formatRelative/index.js": [
		9141,
		7,
		9141
	],
	"./el/_lib/localize": [
		19609,
		7,
		19609
	],
	"./el/_lib/localize/": [
		19609,
		7,
		19609
	],
	"./el/_lib/localize/index": [
		19609,
		7,
		19609
	],
	"./el/_lib/localize/index.js": [
		19609,
		7,
		19609
	],
	"./el/_lib/match": [
		68522,
		7,
		68522
	],
	"./el/_lib/match/": [
		68522,
		7,
		68522
	],
	"./el/_lib/match/index": [
		68522,
		7,
		68522
	],
	"./el/_lib/match/index.js": [
		68522,
		7,
		68522
	],
	"./el/index": [
		24929,
		7,
		24929
	],
	"./el/index.d": [
		61584,
		9,
		61584
	],
	"./el/index.d.ts": [
		61584,
		9,
		61584
	],
	"./el/index.js": [
		24929,
		7,
		24929
	],
	"./el/index.js.flow": [
		87017,
		7,
		87017
	],
	"./el/package": [
		60885,
		3,
		60885
	],
	"./el/package.json": [
		60885,
		3,
		60885
	],
	"./el/snapshot.md": [
		52465,
		7,
		52465
	],
	"./en-AU": [
		43129,
		9,
		44584
	],
	"./en-AU/": [
		43129,
		9,
		44584
	],
	"./en-AU/_lib/formatLong": [
		36631,
		7,
		36631
	],
	"./en-AU/_lib/formatLong/": [
		36631,
		7,
		36631
	],
	"./en-AU/_lib/formatLong/index": [
		36631,
		7,
		36631
	],
	"./en-AU/_lib/formatLong/index.js": [
		36631,
		7,
		36631
	],
	"./en-AU/index": [
		65725,
		7,
		47847
	],
	"./en-AU/index.d": [
		44584,
		9,
		44584
	],
	"./en-AU/index.d.ts": [
		44584,
		9,
		44584
	],
	"./en-AU/index.js": [
		65725,
		7,
		47847
	],
	"./en-AU/index.js.flow": [
		45024,
		7,
		45024
	],
	"./en-AU/package": [
		98418,
		3,
		98418
	],
	"./en-AU/package.json": [
		98418,
		3,
		98418
	],
	"./en-AU/snapshot.md": [
		54425,
		7,
		54425
	],
	"./en-CA": [
		36365,
		9,
		32290
	],
	"./en-CA/": [
		36365,
		9,
		32290
	],
	"./en-CA/_lib/formatDistance": [
		94270,
		7,
		94270
	],
	"./en-CA/_lib/formatDistance/": [
		94270,
		7,
		94270
	],
	"./en-CA/_lib/formatDistance/index": [
		94270,
		7,
		94270
	],
	"./en-CA/_lib/formatDistance/index.js": [
		94270,
		7,
		94270
	],
	"./en-CA/_lib/formatLong": [
		36057,
		7,
		69093
	],
	"./en-CA/_lib/formatLong/": [
		36057,
		7,
		69093
	],
	"./en-CA/_lib/formatLong/index": [
		36057,
		7,
		69093
	],
	"./en-CA/_lib/formatLong/index.js": [
		36057,
		7,
		69093
	],
	"./en-CA/index": [
		63907,
		7,
		63907
	],
	"./en-CA/index.d": [
		32290,
		9,
		32290
	],
	"./en-CA/index.d.ts": [
		32290,
		9,
		32290
	],
	"./en-CA/index.js": [
		63907,
		7,
		63907
	],
	"./en-CA/index.js.flow": [
		10720,
		7,
		10720
	],
	"./en-CA/package": [
		18428,
		3,
		18428
	],
	"./en-CA/package.json": [
		18428,
		3,
		18428
	],
	"./en-CA/snapshot.md": [
		16844,
		7,
		16844
	],
	"./en-GB": [
		2876,
		9,
		11986
	],
	"./en-GB/": [
		2876,
		9,
		11986
	],
	"./en-GB/_lib/formatLong": [
		76122,
		7,
		76122
	],
	"./en-GB/_lib/formatLong/": [
		76122,
		7,
		76122
	],
	"./en-GB/_lib/formatLong/index": [
		76122,
		7,
		76122
	],
	"./en-GB/_lib/formatLong/index.js": [
		76122,
		7,
		76122
	],
	"./en-GB/index": [
		50840,
		7,
		47847
	],
	"./en-GB/index.d": [
		11986,
		9,
		11986
	],
	"./en-GB/index.d.ts": [
		11986,
		9,
		11986
	],
	"./en-GB/index.js": [
		50840,
		7,
		47847
	],
	"./en-GB/index.js.flow": [
		25413,
		7,
		25413
	],
	"./en-GB/package": [
		53441,
		3,
		53441
	],
	"./en-GB/package.json": [
		53441,
		3,
		53441
	],
	"./en-GB/snapshot.md": [
		48114,
		7,
		48114
	],
	"./en-IN": [
		37188,
		9,
		71506
	],
	"./en-IN/": [
		37188,
		9,
		71506
	],
	"./en-IN/_lib/formatLong": [
		16723,
		7,
		16723
	],
	"./en-IN/_lib/formatLong/": [
		16723,
		7,
		16723
	],
	"./en-IN/_lib/formatLong/index": [
		16723,
		7,
		16723
	],
	"./en-IN/_lib/formatLong/index.js": [
		16723,
		7,
		16723
	],
	"./en-IN/index": [
		56482,
		7,
		47847
	],
	"./en-IN/index.d": [
		71506,
		9,
		71506
	],
	"./en-IN/index.d.ts": [
		71506,
		9,
		71506
	],
	"./en-IN/index.js": [
		56482,
		7,
		47847
	],
	"./en-IN/index.js.flow": [
		65273,
		7,
		65273
	],
	"./en-IN/package": [
		32554,
		3,
		32554
	],
	"./en-IN/package.json": [
		32554,
		3,
		32554
	],
	"./en-IN/snapshot.md": [
		7636,
		7,
		7636
	],
	"./en-NZ": [
		62495,
		9,
		42668
	],
	"./en-NZ/": [
		62495,
		9,
		42668
	],
	"./en-NZ/_lib/formatLong": [
		52219,
		7,
		52219
	],
	"./en-NZ/_lib/formatLong/": [
		52219,
		7,
		52219
	],
	"./en-NZ/_lib/formatLong/index": [
		52219,
		7,
		52219
	],
	"./en-NZ/_lib/formatLong/index.js": [
		52219,
		7,
		52219
	],
	"./en-NZ/index": [
		79606,
		7,
		47847
	],
	"./en-NZ/index.d": [
		42668,
		9,
		42668
	],
	"./en-NZ/index.d.ts": [
		42668,
		9,
		42668
	],
	"./en-NZ/index.js": [
		79606,
		7,
		47847
	],
	"./en-NZ/index.js.flow": [
		51648,
		7,
		51648
	],
	"./en-NZ/package": [
		18375,
		3,
		18375
	],
	"./en-NZ/package.json": [
		18375,
		3,
		18375
	],
	"./en-NZ/snapshot.md": [
		96940,
		7,
		96940
	],
	"./en-US": [
		93644,
		9
	],
	"./en-US/": [
		93644,
		9
	],
	"./en-US/_lib/formatDistance": [
		55975,
		7,
		55975
	],
	"./en-US/_lib/formatDistance/": [
		55975,
		7,
		55975
	],
	"./en-US/_lib/formatDistance/index": [
		55975,
		7,
		55975
	],
	"./en-US/_lib/formatDistance/index.js": [
		55975,
		7,
		55975
	],
	"./en-US/_lib/formatLong": [
		56882,
		7,
		56882
	],
	"./en-US/_lib/formatLong/": [
		56882,
		7,
		56882
	],
	"./en-US/_lib/formatLong/index": [
		56882,
		7,
		56882
	],
	"./en-US/_lib/formatLong/index.js": [
		56882,
		7,
		56882
	],
	"./en-US/_lib/formatRelative": [
		60145,
		7,
		60145
	],
	"./en-US/_lib/formatRelative/": [
		60145,
		7,
		60145
	],
	"./en-US/_lib/formatRelative/index": [
		60145,
		7,
		60145
	],
	"./en-US/_lib/formatRelative/index.js": [
		60145,
		7,
		60145
	],
	"./en-US/_lib/localize": [
		30736,
		7,
		30736
	],
	"./en-US/_lib/localize/": [
		30736,
		7,
		30736
	],
	"./en-US/_lib/localize/index": [
		30736,
		7,
		30736
	],
	"./en-US/_lib/localize/index.js": [
		30736,
		7,
		30736
	],
	"./en-US/_lib/match": [
		32200,
		7,
		32200
	],
	"./en-US/_lib/match/": [
		32200,
		7,
		32200
	],
	"./en-US/_lib/match/index": [
		32200,
		7,
		32200
	],
	"./en-US/_lib/match/index.js": [
		32200,
		7,
		32200
	],
	"./en-US/index": [
		8302,
		7,
		47847
	],
	"./en-US/index.d": [
		78255,
		9,
		78255
	],
	"./en-US/index.d.ts": [
		78255,
		9,
		78255
	],
	"./en-US/index.js": [
		8302,
		7,
		47847
	],
	"./en-US/index.js.flow": [
		4104,
		7,
		4104
	],
	"./en-US/package": [
		52867,
		3,
		52867
	],
	"./en-US/package.json": [
		52867,
		3,
		52867
	],
	"./en-US/snapshot.md": [
		36015,
		7,
		36015
	],
	"./eo": [
		28815,
		9,
		70900
	],
	"./eo/": [
		28815,
		9,
		70900
	],
	"./eo/_lib/formatDistance": [
		44380,
		7,
		44380
	],
	"./eo/_lib/formatDistance/": [
		44380,
		7,
		44380
	],
	"./eo/_lib/formatDistance/index": [
		44380,
		7,
		44380
	],
	"./eo/_lib/formatDistance/index.js": [
		44380,
		7,
		44380
	],
	"./eo/_lib/formatLong": [
		86081,
		7,
		86081
	],
	"./eo/_lib/formatLong/": [
		86081,
		7,
		86081
	],
	"./eo/_lib/formatLong/index": [
		86081,
		7,
		86081
	],
	"./eo/_lib/formatLong/index.js": [
		86081,
		7,
		86081
	],
	"./eo/_lib/formatRelative": [
		6661,
		7,
		6661
	],
	"./eo/_lib/formatRelative/": [
		6661,
		7,
		6661
	],
	"./eo/_lib/formatRelative/index": [
		6661,
		7,
		6661
	],
	"./eo/_lib/formatRelative/index.js": [
		6661,
		7,
		6661
	],
	"./eo/_lib/localize": [
		3643,
		7,
		92993
	],
	"./eo/_lib/localize/": [
		3643,
		7,
		92993
	],
	"./eo/_lib/localize/index": [
		3643,
		7,
		92993
	],
	"./eo/_lib/localize/index.js": [
		3643,
		7,
		92993
	],
	"./eo/_lib/match": [
		85852,
		7,
		85852
	],
	"./eo/_lib/match/": [
		85852,
		7,
		85852
	],
	"./eo/_lib/match/index": [
		85852,
		7,
		85852
	],
	"./eo/_lib/match/index.js": [
		85852,
		7,
		85852
	],
	"./eo/index": [
		3994,
		7,
		3994
	],
	"./eo/index.d": [
		70900,
		9,
		70900
	],
	"./eo/index.d.ts": [
		70900,
		9,
		70900
	],
	"./eo/index.js": [
		3994,
		7,
		3994
	],
	"./eo/index.js.flow": [
		65354,
		7,
		65354
	],
	"./eo/package": [
		67256,
		3,
		67256
	],
	"./eo/package.json": [
		67256,
		3,
		67256
	],
	"./eo/snapshot.md": [
		87541,
		7,
		87541
	],
	"./es": [
		99977,
		9,
		80037
	],
	"./es/": [
		99977,
		9,
		80037
	],
	"./es/_lib/formatDistance": [
		75017,
		7,
		75017
	],
	"./es/_lib/formatDistance/": [
		75017,
		7,
		75017
	],
	"./es/_lib/formatDistance/index": [
		75017,
		7,
		75017
	],
	"./es/_lib/formatDistance/index.js": [
		75017,
		7,
		75017
	],
	"./es/_lib/formatLong": [
		59003,
		7,
		59003
	],
	"./es/_lib/formatLong/": [
		59003,
		7,
		59003
	],
	"./es/_lib/formatLong/index": [
		59003,
		7,
		59003
	],
	"./es/_lib/formatLong/index.js": [
		59003,
		7,
		59003
	],
	"./es/_lib/formatRelative": [
		71275,
		7,
		71275
	],
	"./es/_lib/formatRelative/": [
		71275,
		7,
		71275
	],
	"./es/_lib/formatRelative/index": [
		71275,
		7,
		71275
	],
	"./es/_lib/formatRelative/index.js": [
		71275,
		7,
		71275
	],
	"./es/_lib/localize": [
		21898,
		7,
		21898
	],
	"./es/_lib/localize/": [
		21898,
		7,
		21898
	],
	"./es/_lib/localize/index": [
		21898,
		7,
		21898
	],
	"./es/_lib/localize/index.js": [
		21898,
		7,
		21898
	],
	"./es/_lib/match": [
		33713,
		7,
		33713
	],
	"./es/_lib/match/": [
		33713,
		7,
		33713
	],
	"./es/_lib/match/index": [
		33713,
		7,
		33713
	],
	"./es/_lib/match/index.js": [
		33713,
		7,
		33713
	],
	"./es/index": [
		56242,
		7,
		56242
	],
	"./es/index.d": [
		80037,
		9,
		80037
	],
	"./es/index.d.ts": [
		80037,
		9,
		80037
	],
	"./es/index.js": [
		56242,
		7,
		56242
	],
	"./es/index.js.flow": [
		70471,
		7,
		70471
	],
	"./es/package": [
		72167,
		3,
		72167
	],
	"./es/package.json": [
		72167,
		3,
		72167
	],
	"./es/snapshot.md": [
		3980,
		7,
		3980
	],
	"./et": [
		4278,
		9,
		46313
	],
	"./et/": [
		4278,
		9,
		46313
	],
	"./et/_lib/formatDistance": [
		29455,
		7,
		29455
	],
	"./et/_lib/formatDistance/": [
		29455,
		7,
		29455
	],
	"./et/_lib/formatDistance/index": [
		29455,
		7,
		29455
	],
	"./et/_lib/formatDistance/index.js": [
		29455,
		7,
		29455
	],
	"./et/_lib/formatLong": [
		64803,
		7,
		64803
	],
	"./et/_lib/formatLong/": [
		64803,
		7,
		64803
	],
	"./et/_lib/formatLong/index": [
		64803,
		7,
		64803
	],
	"./et/_lib/formatLong/index.js": [
		64803,
		7,
		64803
	],
	"./et/_lib/formatRelative": [
		18925,
		7,
		18925
	],
	"./et/_lib/formatRelative/": [
		18925,
		7,
		18925
	],
	"./et/_lib/formatRelative/index": [
		18925,
		7,
		18925
	],
	"./et/_lib/formatRelative/index.js": [
		18925,
		7,
		18925
	],
	"./et/_lib/localize": [
		76228,
		7,
		76228
	],
	"./et/_lib/localize/": [
		76228,
		7,
		76228
	],
	"./et/_lib/localize/index": [
		76228,
		7,
		76228
	],
	"./et/_lib/localize/index.js": [
		76228,
		7,
		76228
	],
	"./et/_lib/match": [
		77002,
		7,
		77002
	],
	"./et/_lib/match/": [
		77002,
		7,
		77002
	],
	"./et/_lib/match/index": [
		77002,
		7,
		77002
	],
	"./et/_lib/match/index.js": [
		77002,
		7,
		77002
	],
	"./et/index": [
		24092,
		7,
		24092
	],
	"./et/index.d": [
		46313,
		9,
		46313
	],
	"./et/index.d.ts": [
		46313,
		9,
		46313
	],
	"./et/index.js": [
		24092,
		7,
		24092
	],
	"./et/index.js.flow": [
		11956,
		7,
		11956
	],
	"./et/package": [
		6698,
		3,
		6698
	],
	"./et/package.json": [
		6698,
		3,
		6698
	],
	"./et/snapshot.md": [
		46849,
		7,
		46849
	],
	"./eu": [
		86659,
		9,
		82293
	],
	"./eu/": [
		86659,
		9,
		82293
	],
	"./eu/_lib/formatDistance": [
		71193,
		7,
		71193
	],
	"./eu/_lib/formatDistance/": [
		71193,
		7,
		71193
	],
	"./eu/_lib/formatDistance/index": [
		71193,
		7,
		71193
	],
	"./eu/_lib/formatDistance/index.js": [
		71193,
		7,
		71193
	],
	"./eu/_lib/formatLong": [
		32162,
		7,
		32162
	],
	"./eu/_lib/formatLong/": [
		32162,
		7,
		32162
	],
	"./eu/_lib/formatLong/index": [
		32162,
		7,
		32162
	],
	"./eu/_lib/formatLong/index.js": [
		32162,
		7,
		32162
	],
	"./eu/_lib/formatRelative": [
		11572,
		7,
		11572
	],
	"./eu/_lib/formatRelative/": [
		11572,
		7,
		11572
	],
	"./eu/_lib/formatRelative/index": [
		11572,
		7,
		11572
	],
	"./eu/_lib/formatRelative/index.js": [
		11572,
		7,
		11572
	],
	"./eu/_lib/localize": [
		89252,
		7,
		89252
	],
	"./eu/_lib/localize/": [
		89252,
		7,
		89252
	],
	"./eu/_lib/localize/index": [
		89252,
		7,
		89252
	],
	"./eu/_lib/localize/index.js": [
		89252,
		7,
		89252
	],
	"./eu/_lib/match": [
		88853,
		7,
		88853
	],
	"./eu/_lib/match/": [
		88853,
		7,
		88853
	],
	"./eu/_lib/match/index": [
		88853,
		7,
		88853
	],
	"./eu/_lib/match/index.js": [
		88853,
		7,
		88853
	],
	"./eu/index": [
		95705,
		7,
		95705
	],
	"./eu/index.d": [
		82293,
		9,
		82293
	],
	"./eu/index.d.ts": [
		82293,
		9,
		82293
	],
	"./eu/index.js": [
		95705,
		7,
		95705
	],
	"./eu/index.js.flow": [
		97173,
		7,
		97173
	],
	"./eu/package": [
		18826,
		3,
		18826
	],
	"./eu/package.json": [
		18826,
		3,
		18826
	],
	"./eu/snapshot.md": [
		10504,
		7,
		10504
	],
	"./fa-IR": [
		22829,
		9,
		17580
	],
	"./fa-IR/": [
		22829,
		9,
		17580
	],
	"./fa-IR/_lib/formatDistance": [
		37656,
		7,
		37656
	],
	"./fa-IR/_lib/formatDistance/": [
		37656,
		7,
		37656
	],
	"./fa-IR/_lib/formatDistance/index": [
		37656,
		7,
		37656
	],
	"./fa-IR/_lib/formatDistance/index.js": [
		37656,
		7,
		37656
	],
	"./fa-IR/_lib/formatLong": [
		15732,
		7,
		15732
	],
	"./fa-IR/_lib/formatLong/": [
		15732,
		7,
		15732
	],
	"./fa-IR/_lib/formatLong/index": [
		15732,
		7,
		15732
	],
	"./fa-IR/_lib/formatLong/index.js": [
		15732,
		7,
		15732
	],
	"./fa-IR/_lib/formatRelative": [
		32616,
		7,
		32616
	],
	"./fa-IR/_lib/formatRelative/": [
		32616,
		7,
		32616
	],
	"./fa-IR/_lib/formatRelative/index": [
		32616,
		7,
		32616
	],
	"./fa-IR/_lib/formatRelative/index.js": [
		32616,
		7,
		32616
	],
	"./fa-IR/_lib/localize": [
		77339,
		7,
		77339
	],
	"./fa-IR/_lib/localize/": [
		77339,
		7,
		77339
	],
	"./fa-IR/_lib/localize/index": [
		77339,
		7,
		77339
	],
	"./fa-IR/_lib/localize/index.js": [
		77339,
		7,
		77339
	],
	"./fa-IR/_lib/match": [
		70124,
		7,
		70124
	],
	"./fa-IR/_lib/match/": [
		70124,
		7,
		70124
	],
	"./fa-IR/_lib/match/index": [
		70124,
		7,
		70124
	],
	"./fa-IR/_lib/match/index.js": [
		70124,
		7,
		70124
	],
	"./fa-IR/index": [
		54636,
		7,
		54636
	],
	"./fa-IR/index.d": [
		17580,
		9,
		17580
	],
	"./fa-IR/index.d.ts": [
		17580,
		9,
		17580
	],
	"./fa-IR/index.js": [
		54636,
		7,
		54636
	],
	"./fa-IR/index.js.flow": [
		27812,
		7,
		27812
	],
	"./fa-IR/package": [
		53592,
		3,
		53592
	],
	"./fa-IR/package.json": [
		53592,
		3,
		53592
	],
	"./fa-IR/snapshot.md": [
		20622,
		7,
		20622
	],
	"./fi": [
		73882,
		9,
		86736
	],
	"./fi/": [
		73882,
		9,
		86736
	],
	"./fi/_lib/formatDistance": [
		92051,
		7,
		92051
	],
	"./fi/_lib/formatDistance/": [
		92051,
		7,
		92051
	],
	"./fi/_lib/formatDistance/index": [
		92051,
		7,
		92051
	],
	"./fi/_lib/formatDistance/index.js": [
		92051,
		7,
		92051
	],
	"./fi/_lib/formatLong": [
		40592,
		7,
		40592
	],
	"./fi/_lib/formatLong/": [
		40592,
		7,
		40592
	],
	"./fi/_lib/formatLong/index": [
		40592,
		7,
		40592
	],
	"./fi/_lib/formatLong/index.js": [
		40592,
		7,
		40592
	],
	"./fi/_lib/formatRelative": [
		5777,
		7,
		5777
	],
	"./fi/_lib/formatRelative/": [
		5777,
		7,
		5777
	],
	"./fi/_lib/formatRelative/index": [
		5777,
		7,
		5777
	],
	"./fi/_lib/formatRelative/index.js": [
		5777,
		7,
		5777
	],
	"./fi/_lib/localize": [
		98000,
		7,
		98000
	],
	"./fi/_lib/localize/": [
		98000,
		7,
		98000
	],
	"./fi/_lib/localize/index": [
		98000,
		7,
		98000
	],
	"./fi/_lib/localize/index.js": [
		98000,
		7,
		98000
	],
	"./fi/_lib/match": [
		82436,
		7,
		82436
	],
	"./fi/_lib/match/": [
		82436,
		7,
		82436
	],
	"./fi/_lib/match/index": [
		82436,
		7,
		82436
	],
	"./fi/_lib/match/index.js": [
		82436,
		7,
		82436
	],
	"./fi/index": [
		74996,
		7,
		74996
	],
	"./fi/index.d": [
		86736,
		9,
		86736
	],
	"./fi/index.d.ts": [
		86736,
		9,
		86736
	],
	"./fi/index.js": [
		74996,
		7,
		74996
	],
	"./fi/index.js.flow": [
		50844,
		7,
		50844
	],
	"./fi/package": [
		86139,
		3,
		86139
	],
	"./fi/package.json": [
		86139,
		3,
		86139
	],
	"./fi/snapshot.md": [
		73688,
		7,
		73688
	],
	"./fr": [
		88503,
		9,
		52561
	],
	"./fr-CA": [
		42762,
		9,
		52561
	],
	"./fr-CA/": [
		42762,
		9,
		52561
	],
	"./fr-CA/_lib/formatLong": [
		44800,
		7,
		44800
	],
	"./fr-CA/_lib/formatLong/": [
		44800,
		7,
		44800
	],
	"./fr-CA/_lib/formatLong/index": [
		44800,
		7,
		44800
	],
	"./fr-CA/_lib/formatLong/index.js": [
		44800,
		7,
		44800
	],
	"./fr-CA/index": [
		46329,
		7,
		53386
	],
	"./fr-CA/index.d": [
		48477,
		9,
		52561
	],
	"./fr-CA/index.d.ts": [
		48477,
		9,
		52561
	],
	"./fr-CA/index.js": [
		46329,
		7,
		53386
	],
	"./fr-CA/index.js.flow": [
		82356,
		7,
		82356
	],
	"./fr-CA/package": [
		75240,
		3,
		75240
	],
	"./fr-CA/package.json": [
		75240,
		3,
		75240
	],
	"./fr-CA/snapshot.md": [
		24160,
		7,
		24160
	],
	"./fr-CH": [
		43585,
		9,
		89265
	],
	"./fr-CH/": [
		43585,
		9,
		89265
	],
	"./fr-CH/_lib/formatDistance": [
		71983,
		7,
		71983
	],
	"./fr-CH/_lib/formatDistance/": [
		71983,
		7,
		71983
	],
	"./fr-CH/_lib/formatDistance/index": [
		71983,
		7,
		71983
	],
	"./fr-CH/_lib/formatDistance/index.js": [
		71983,
		7,
		71983
	],
	"./fr-CH/_lib/formatLong": [
		97622,
		7,
		97622
	],
	"./fr-CH/_lib/formatLong/": [
		97622,
		7,
		97622
	],
	"./fr-CH/_lib/formatLong/index": [
		97622,
		7,
		97622
	],
	"./fr-CH/_lib/formatLong/index.js": [
		97622,
		7,
		97622
	],
	"./fr-CH/_lib/formatRelative": [
		21991,
		7,
		21991
	],
	"./fr-CH/_lib/formatRelative/": [
		21991,
		7,
		21991
	],
	"./fr-CH/_lib/formatRelative/index": [
		21991,
		7,
		21991
	],
	"./fr-CH/_lib/formatRelative/index.js": [
		21991,
		7,
		21991
	],
	"./fr-CH/_lib/formatters": [
		93646,
		7,
		93646
	],
	"./fr-CH/_lib/formatters/": [
		93646,
		7,
		93646
	],
	"./fr-CH/_lib/formatters/index": [
		93646,
		7,
		93646
	],
	"./fr-CH/_lib/formatters/index.js": [
		93646,
		7,
		93646
	],
	"./fr-CH/_lib/localize": [
		19079,
		7,
		19079
	],
	"./fr-CH/_lib/localize/": [
		19079,
		7,
		19079
	],
	"./fr-CH/_lib/localize/index": [
		19079,
		7,
		19079
	],
	"./fr-CH/_lib/localize/index.js": [
		19079,
		7,
		19079
	],
	"./fr-CH/_lib/match": [
		6866,
		7,
		6866
	],
	"./fr-CH/_lib/match/": [
		6866,
		7,
		6866
	],
	"./fr-CH/_lib/match/index": [
		6866,
		7,
		6866
	],
	"./fr-CH/_lib/match/index.js": [
		6866,
		7,
		6866
	],
	"./fr-CH/index": [
		94939,
		7,
		94939
	],
	"./fr-CH/index.d": [
		89265,
		9,
		89265
	],
	"./fr-CH/index.d.ts": [
		89265,
		9,
		89265
	],
	"./fr-CH/index.js": [
		94939,
		7,
		94939
	],
	"./fr-CH/index.js.flow": [
		95363,
		7,
		95363
	],
	"./fr-CH/package": [
		42350,
		3,
		42350
	],
	"./fr-CH/package.json": [
		42350,
		3,
		42350
	],
	"./fr-CH/snapshot.md": [
		17186,
		7,
		17186
	],
	"./fr/": [
		88503,
		9,
		52561
	],
	"./fr/_lib/formatDistance": [
		47569,
		7,
		47569
	],
	"./fr/_lib/formatDistance/": [
		47569,
		7,
		47569
	],
	"./fr/_lib/formatDistance/index": [
		47569,
		7,
		47569
	],
	"./fr/_lib/formatDistance/index.js": [
		47569,
		7,
		47569
	],
	"./fr/_lib/formatLong": [
		90320,
		7,
		90320
	],
	"./fr/_lib/formatLong/": [
		90320,
		7,
		90320
	],
	"./fr/_lib/formatLong/index": [
		90320,
		7,
		90320
	],
	"./fr/_lib/formatLong/index.js": [
		90320,
		7,
		90320
	],
	"./fr/_lib/formatRelative": [
		68002,
		7,
		68002
	],
	"./fr/_lib/formatRelative/": [
		68002,
		7,
		68002
	],
	"./fr/_lib/formatRelative/index": [
		68002,
		7,
		68002
	],
	"./fr/_lib/formatRelative/index.js": [
		68002,
		7,
		68002
	],
	"./fr/_lib/formatters": [
		28709,
		7,
		28709
	],
	"./fr/_lib/formatters/": [
		28709,
		7,
		28709
	],
	"./fr/_lib/formatters/index": [
		28709,
		7,
		28709
	],
	"./fr/_lib/formatters/index.js": [
		28709,
		7,
		28709
	],
	"./fr/_lib/localize": [
		86617,
		7,
		86617
	],
	"./fr/_lib/localize/": [
		86617,
		7,
		86617
	],
	"./fr/_lib/localize/index": [
		86617,
		7,
		86617
	],
	"./fr/_lib/localize/index.js": [
		86617,
		7,
		86617
	],
	"./fr/_lib/match": [
		94828,
		7,
		94828
	],
	"./fr/_lib/match/": [
		94828,
		7,
		94828
	],
	"./fr/_lib/match/index": [
		94828,
		7,
		94828
	],
	"./fr/_lib/match/index.js": [
		94828,
		7,
		94828
	],
	"./fr/index": [
		88078,
		7,
		53386
	],
	"./fr/index.d": [
		97139,
		9,
		52561
	],
	"./fr/index.d.ts": [
		97139,
		9,
		52561
	],
	"./fr/index.js": [
		88078,
		7,
		53386
	],
	"./fr/index.js.flow": [
		94247,
		7,
		94247
	],
	"./fr/package": [
		67071,
		3,
		67071
	],
	"./fr/package.json": [
		67071,
		3,
		67071
	],
	"./fr/snapshot.md": [
		65498,
		7,
		65498
	],
	"./gd": [
		81330,
		9,
		22296
	],
	"./gd/": [
		81330,
		9,
		22296
	],
	"./gd/_lib/formatDistance": [
		86126,
		7,
		86126
	],
	"./gd/_lib/formatDistance/": [
		86126,
		7,
		86126
	],
	"./gd/_lib/formatDistance/index": [
		86126,
		7,
		86126
	],
	"./gd/_lib/formatDistance/index.js": [
		86126,
		7,
		86126
	],
	"./gd/_lib/formatLong": [
		94710,
		7,
		94710
	],
	"./gd/_lib/formatLong/": [
		94710,
		7,
		94710
	],
	"./gd/_lib/formatLong/index": [
		94710,
		7,
		94710
	],
	"./gd/_lib/formatLong/index.js": [
		94710,
		7,
		94710
	],
	"./gd/_lib/formatRelative": [
		15247,
		7,
		15247
	],
	"./gd/_lib/formatRelative/": [
		15247,
		7,
		15247
	],
	"./gd/_lib/formatRelative/index": [
		15247,
		7,
		15247
	],
	"./gd/_lib/formatRelative/index.js": [
		15247,
		7,
		15247
	],
	"./gd/_lib/localize": [
		39272,
		7,
		39272
	],
	"./gd/_lib/localize/": [
		39272,
		7,
		39272
	],
	"./gd/_lib/localize/index": [
		39272,
		7,
		39272
	],
	"./gd/_lib/localize/index.js": [
		39272,
		7,
		39272
	],
	"./gd/_lib/match": [
		81612,
		7,
		81612
	],
	"./gd/_lib/match/": [
		81612,
		7,
		81612
	],
	"./gd/_lib/match/index": [
		81612,
		7,
		81612
	],
	"./gd/_lib/match/index.js": [
		81612,
		7,
		81612
	],
	"./gd/index": [
		99998,
		7,
		99998
	],
	"./gd/index.d": [
		22296,
		9,
		22296
	],
	"./gd/index.d.ts": [
		22296,
		9,
		22296
	],
	"./gd/index.js": [
		99998,
		7,
		99998
	],
	"./gd/index.js.flow": [
		44125,
		7,
		44125
	],
	"./gd/package": [
		25901,
		3,
		25901
	],
	"./gd/package.json": [
		25901,
		3,
		25901
	],
	"./gd/snapshot.md": [
		9170,
		7,
		9170
	],
	"./gl": [
		66588,
		9,
		84065
	],
	"./gl/": [
		66588,
		9,
		84065
	],
	"./gl/_lib/formatDistance": [
		27698,
		7,
		27698
	],
	"./gl/_lib/formatDistance/": [
		27698,
		7,
		27698
	],
	"./gl/_lib/formatDistance/index": [
		27698,
		7,
		27698
	],
	"./gl/_lib/formatDistance/index.js": [
		27698,
		7,
		27698
	],
	"./gl/_lib/formatLong": [
		91616,
		7,
		91616
	],
	"./gl/_lib/formatLong/": [
		91616,
		7,
		91616
	],
	"./gl/_lib/formatLong/index": [
		91616,
		7,
		91616
	],
	"./gl/_lib/formatLong/index.js": [
		91616,
		7,
		91616
	],
	"./gl/_lib/formatRelative": [
		42153,
		7,
		42153
	],
	"./gl/_lib/formatRelative/": [
		42153,
		7,
		42153
	],
	"./gl/_lib/formatRelative/index": [
		42153,
		7,
		42153
	],
	"./gl/_lib/formatRelative/index.js": [
		42153,
		7,
		42153
	],
	"./gl/_lib/localize": [
		36447,
		7,
		36447
	],
	"./gl/_lib/localize/": [
		36447,
		7,
		36447
	],
	"./gl/_lib/localize/index": [
		36447,
		7,
		36447
	],
	"./gl/_lib/localize/index.js": [
		36447,
		7,
		36447
	],
	"./gl/_lib/match": [
		29723,
		7,
		29723
	],
	"./gl/_lib/match/": [
		29723,
		7,
		29723
	],
	"./gl/_lib/match/index": [
		29723,
		7,
		29723
	],
	"./gl/_lib/match/index.js": [
		29723,
		7,
		29723
	],
	"./gl/index": [
		94365,
		7,
		94365
	],
	"./gl/index.d": [
		84065,
		9,
		84065
	],
	"./gl/index.d.ts": [
		84065,
		9,
		84065
	],
	"./gl/index.js": [
		94365,
		7,
		94365
	],
	"./gl/index.js.flow": [
		88559,
		7,
		88559
	],
	"./gl/package": [
		19932,
		3,
		19932
	],
	"./gl/package.json": [
		19932,
		3,
		19932
	],
	"./gl/snapshot.md": [
		36283,
		7,
		36283
	],
	"./gu": [
		19223,
		9,
		92947
	],
	"./gu/": [
		19223,
		9,
		92947
	],
	"./gu/_lib/formatDistance": [
		19734,
		7,
		19734
	],
	"./gu/_lib/formatDistance/": [
		19734,
		7,
		19734
	],
	"./gu/_lib/formatDistance/index": [
		19734,
		7,
		19734
	],
	"./gu/_lib/formatDistance/index.js": [
		19734,
		7,
		19734
	],
	"./gu/_lib/formatLong": [
		39930,
		7,
		39930
	],
	"./gu/_lib/formatLong/": [
		39930,
		7,
		39930
	],
	"./gu/_lib/formatLong/index": [
		39930,
		7,
		39930
	],
	"./gu/_lib/formatLong/index.js": [
		39930,
		7,
		39930
	],
	"./gu/_lib/formatRelative": [
		13911,
		7,
		24417
	],
	"./gu/_lib/formatRelative/": [
		13911,
		7,
		24417
	],
	"./gu/_lib/formatRelative/index": [
		13911,
		7,
		24417
	],
	"./gu/_lib/formatRelative/index.js": [
		13911,
		7,
		24417
	],
	"./gu/_lib/localize": [
		63652,
		7,
		63652
	],
	"./gu/_lib/localize/": [
		63652,
		7,
		63652
	],
	"./gu/_lib/localize/index": [
		63652,
		7,
		63652
	],
	"./gu/_lib/localize/index.js": [
		63652,
		7,
		63652
	],
	"./gu/_lib/match": [
		15746,
		7,
		15746
	],
	"./gu/_lib/match/": [
		15746,
		7,
		15746
	],
	"./gu/_lib/match/index": [
		15746,
		7,
		15746
	],
	"./gu/_lib/match/index.js": [
		15746,
		7,
		15746
	],
	"./gu/index": [
		35280,
		7,
		35280
	],
	"./gu/index.d": [
		92947,
		9,
		92947
	],
	"./gu/index.d.ts": [
		92947,
		9,
		92947
	],
	"./gu/index.js": [
		35280,
		7,
		35280
	],
	"./gu/index.js.flow": [
		99184,
		7,
		99184
	],
	"./gu/package": [
		80142,
		3,
		80142
	],
	"./gu/package.json": [
		80142,
		3,
		80142
	],
	"./gu/snapshot.md": [
		24230,
		7,
		24230
	],
	"./he": [
		74260,
		9,
		91266
	],
	"./he/": [
		74260,
		9,
		91266
	],
	"./he/_lib/formatDistance": [
		26740,
		7,
		26740
	],
	"./he/_lib/formatDistance/": [
		26740,
		7,
		26740
	],
	"./he/_lib/formatDistance/index": [
		26740,
		7,
		26740
	],
	"./he/_lib/formatDistance/index.js": [
		26740,
		7,
		26740
	],
	"./he/_lib/formatLong": [
		84917,
		7,
		84917
	],
	"./he/_lib/formatLong/": [
		84917,
		7,
		84917
	],
	"./he/_lib/formatLong/index": [
		84917,
		7,
		84917
	],
	"./he/_lib/formatLong/index.js": [
		84917,
		7,
		84917
	],
	"./he/_lib/formatRelative": [
		24866,
		7,
		24866
	],
	"./he/_lib/formatRelative/": [
		24866,
		7,
		24866
	],
	"./he/_lib/formatRelative/index": [
		24866,
		7,
		24866
	],
	"./he/_lib/formatRelative/index.js": [
		24866,
		7,
		24866
	],
	"./he/_lib/localize": [
		24716,
		7,
		24716
	],
	"./he/_lib/localize/": [
		24716,
		7,
		24716
	],
	"./he/_lib/localize/index": [
		24716,
		7,
		24716
	],
	"./he/_lib/localize/index.js": [
		24716,
		7,
		24716
	],
	"./he/_lib/match": [
		37195,
		7,
		37195
	],
	"./he/_lib/match/": [
		37195,
		7,
		37195
	],
	"./he/_lib/match/index": [
		37195,
		7,
		37195
	],
	"./he/_lib/match/index.js": [
		37195,
		7,
		37195
	],
	"./he/index": [
		56561,
		7,
		56561
	],
	"./he/index.d": [
		91266,
		9,
		91266
	],
	"./he/index.d.ts": [
		91266,
		9,
		91266
	],
	"./he/index.js": [
		56561,
		7,
		56561
	],
	"./he/index.js.flow": [
		66200,
		7,
		66200
	],
	"./he/package": [
		37042,
		3,
		37042
	],
	"./he/package.json": [
		37042,
		3,
		37042
	],
	"./he/snapshot.md": [
		21030,
		7,
		21030
	],
	"./hi": [
		18510,
		9,
		91119
	],
	"./hi/": [
		18510,
		9,
		91119
	],
	"./hi/_lib/formatDistance": [
		9234,
		7,
		9234
	],
	"./hi/_lib/formatDistance/": [
		9234,
		7,
		9234
	],
	"./hi/_lib/formatDistance/index": [
		9234,
		7,
		9234
	],
	"./hi/_lib/formatDistance/index.js": [
		9234,
		7,
		9234
	],
	"./hi/_lib/formatLong": [
		22819,
		7,
		22819
	],
	"./hi/_lib/formatLong/": [
		22819,
		7,
		22819
	],
	"./hi/_lib/formatLong/index": [
		22819,
		7,
		22819
	],
	"./hi/_lib/formatLong/index.js": [
		22819,
		7,
		22819
	],
	"./hi/_lib/formatRelative": [
		93677,
		7,
		93677
	],
	"./hi/_lib/formatRelative/": [
		93677,
		7,
		93677
	],
	"./hi/_lib/formatRelative/index": [
		93677,
		7,
		93677
	],
	"./hi/_lib/formatRelative/index.js": [
		93677,
		7,
		93677
	],
	"./hi/_lib/localize": [
		21001,
		7,
		9234
	],
	"./hi/_lib/localize/": [
		21001,
		7,
		9234
	],
	"./hi/_lib/localize/index": [
		21001,
		7,
		9234
	],
	"./hi/_lib/localize/index.js": [
		21001,
		7,
		9234
	],
	"./hi/_lib/match": [
		63585,
		7,
		31674
	],
	"./hi/_lib/match/": [
		63585,
		7,
		31674
	],
	"./hi/_lib/match/index": [
		63585,
		7,
		31674
	],
	"./hi/_lib/match/index.js": [
		63585,
		7,
		31674
	],
	"./hi/index": [
		31674,
		7,
		31674
	],
	"./hi/index.d": [
		91119,
		9,
		91119
	],
	"./hi/index.d.ts": [
		91119,
		9,
		91119
	],
	"./hi/index.js": [
		31674,
		7,
		31674
	],
	"./hi/index.js.flow": [
		64721,
		7,
		64721
	],
	"./hi/package": [
		22801,
		3,
		37942
	],
	"./hi/package.json": [
		22801,
		3,
		37942
	],
	"./hi/snapshot.md": [
		50361,
		7,
		50361
	],
	"./hr": [
		56968,
		9,
		20515
	],
	"./hr/": [
		56968,
		9,
		20515
	],
	"./hr/_lib/formatDistance": [
		15789,
		7,
		15789
	],
	"./hr/_lib/formatDistance/": [
		15789,
		7,
		15789
	],
	"./hr/_lib/formatDistance/index": [
		15789,
		7,
		15789
	],
	"./hr/_lib/formatDistance/index.js": [
		15789,
		7,
		15789
	],
	"./hr/_lib/formatLong": [
		88465,
		7,
		88465
	],
	"./hr/_lib/formatLong/": [
		88465,
		7,
		88465
	],
	"./hr/_lib/formatLong/index": [
		88465,
		7,
		88465
	],
	"./hr/_lib/formatLong/index.js": [
		88465,
		7,
		88465
	],
	"./hr/_lib/formatRelative": [
		62901,
		7,
		62901
	],
	"./hr/_lib/formatRelative/": [
		62901,
		7,
		62901
	],
	"./hr/_lib/formatRelative/index": [
		62901,
		7,
		62901
	],
	"./hr/_lib/formatRelative/index.js": [
		62901,
		7,
		62901
	],
	"./hr/_lib/localize": [
		77212,
		7,
		77212
	],
	"./hr/_lib/localize/": [
		77212,
		7,
		77212
	],
	"./hr/_lib/localize/index": [
		77212,
		7,
		77212
	],
	"./hr/_lib/localize/index.js": [
		77212,
		7,
		77212
	],
	"./hr/_lib/match": [
		47868,
		7,
		47868
	],
	"./hr/_lib/match/": [
		47868,
		7,
		47868
	],
	"./hr/_lib/match/index": [
		47868,
		7,
		47868
	],
	"./hr/_lib/match/index.js": [
		47868,
		7,
		47868
	],
	"./hr/index": [
		5367,
		7,
		5367
	],
	"./hr/index.d": [
		20515,
		9,
		20515
	],
	"./hr/index.d.ts": [
		20515,
		9,
		20515
	],
	"./hr/index.js": [
		5367,
		7,
		5367
	],
	"./hr/index.js.flow": [
		59673,
		7,
		59673
	],
	"./hr/package": [
		2272,
		3,
		2272
	],
	"./hr/package.json": [
		2272,
		3,
		2272
	],
	"./hr/snapshot.md": [
		53564,
		7,
		53564
	],
	"./hu": [
		95500,
		9,
		55744
	],
	"./hu/": [
		95500,
		9,
		55744
	],
	"./hu/_lib/formatDistance": [
		47967,
		7,
		47967
	],
	"./hu/_lib/formatDistance/": [
		47967,
		7,
		47967
	],
	"./hu/_lib/formatDistance/index": [
		47967,
		7,
		47967
	],
	"./hu/_lib/formatDistance/index.js": [
		47967,
		7,
		47967
	],
	"./hu/_lib/formatLong": [
		81592,
		7,
		81592
	],
	"./hu/_lib/formatLong/": [
		81592,
		7,
		81592
	],
	"./hu/_lib/formatLong/index": [
		81592,
		7,
		81592
	],
	"./hu/_lib/formatLong/index.js": [
		81592,
		7,
		81592
	],
	"./hu/_lib/formatRelative": [
		97322,
		7,
		97322
	],
	"./hu/_lib/formatRelative/": [
		97322,
		7,
		97322
	],
	"./hu/_lib/formatRelative/index": [
		97322,
		7,
		97322
	],
	"./hu/_lib/formatRelative/index.js": [
		97322,
		7,
		97322
	],
	"./hu/_lib/localize": [
		21402,
		7,
		21402
	],
	"./hu/_lib/localize/": [
		21402,
		7,
		21402
	],
	"./hu/_lib/localize/index": [
		21402,
		7,
		21402
	],
	"./hu/_lib/localize/index.js": [
		21402,
		7,
		21402
	],
	"./hu/_lib/match": [
		28681,
		7,
		28681
	],
	"./hu/_lib/match/": [
		28681,
		7,
		28681
	],
	"./hu/_lib/match/index": [
		28681,
		7,
		28681
	],
	"./hu/_lib/match/index.js": [
		28681,
		7,
		28681
	],
	"./hu/index": [
		8840,
		7,
		8840
	],
	"./hu/index.d": [
		55744,
		9,
		55744
	],
	"./hu/index.d.ts": [
		55744,
		9,
		55744
	],
	"./hu/index.js": [
		8840,
		7,
		8840
	],
	"./hu/index.js.flow": [
		69972,
		7,
		69972
	],
	"./hu/package": [
		33223,
		3,
		33223
	],
	"./hu/package.json": [
		33223,
		3,
		33223
	],
	"./hu/snapshot.md": [
		5854,
		7,
		5854
	],
	"./hy": [
		67554,
		9,
		35547
	],
	"./hy/": [
		67554,
		9,
		35547
	],
	"./hy/_lib/formatDistance": [
		32641,
		7,
		32641
	],
	"./hy/_lib/formatDistance/": [
		32641,
		7,
		32641
	],
	"./hy/_lib/formatDistance/index": [
		32641,
		7,
		32641
	],
	"./hy/_lib/formatDistance/index.js": [
		32641,
		7,
		32641
	],
	"./hy/_lib/formatLong": [
		30010,
		7,
		30010
	],
	"./hy/_lib/formatLong/": [
		30010,
		7,
		30010
	],
	"./hy/_lib/formatLong/index": [
		30010,
		7,
		30010
	],
	"./hy/_lib/formatLong/index.js": [
		30010,
		7,
		30010
	],
	"./hy/_lib/formatRelative": [
		16238,
		7,
		16238
	],
	"./hy/_lib/formatRelative/": [
		16238,
		7,
		16238
	],
	"./hy/_lib/formatRelative/index": [
		16238,
		7,
		16238
	],
	"./hy/_lib/formatRelative/index.js": [
		16238,
		7,
		16238
	],
	"./hy/_lib/localize": [
		45317,
		7,
		45317
	],
	"./hy/_lib/localize/": [
		45317,
		7,
		45317
	],
	"./hy/_lib/localize/index": [
		45317,
		7,
		45317
	],
	"./hy/_lib/localize/index.js": [
		45317,
		7,
		45317
	],
	"./hy/_lib/match": [
		6373,
		7,
		6373
	],
	"./hy/_lib/match/": [
		6373,
		7,
		6373
	],
	"./hy/_lib/match/index": [
		6373,
		7,
		6373
	],
	"./hy/_lib/match/index.js": [
		6373,
		7,
		6373
	],
	"./hy/index": [
		83011,
		7,
		83011
	],
	"./hy/index.d": [
		35547,
		9,
		35547
	],
	"./hy/index.d.ts": [
		35547,
		9,
		35547
	],
	"./hy/index.js": [
		83011,
		7,
		83011
	],
	"./hy/index.js.flow": [
		88132,
		7,
		88132
	],
	"./hy/package": [
		12515,
		3,
		12515
	],
	"./hy/package.json": [
		12515,
		3,
		12515
	],
	"./hy/snapshot.md": [
		71942,
		7,
		71942
	],
	"./id": [
		59331,
		9,
		32512
	],
	"./id/": [
		59331,
		9,
		32512
	],
	"./id/_lib/formatDistance": [
		42623,
		7,
		42623
	],
	"./id/_lib/formatDistance/": [
		42623,
		7,
		42623
	],
	"./id/_lib/formatDistance/index": [
		42623,
		7,
		42623
	],
	"./id/_lib/formatDistance/index.js": [
		42623,
		7,
		42623
	],
	"./id/_lib/formatLong": [
		94505,
		7,
		94505
	],
	"./id/_lib/formatLong/": [
		94505,
		7,
		94505
	],
	"./id/_lib/formatLong/index": [
		94505,
		7,
		94505
	],
	"./id/_lib/formatLong/index.js": [
		94505,
		7,
		94505
	],
	"./id/_lib/formatRelative": [
		60762,
		7,
		60762
	],
	"./id/_lib/formatRelative/": [
		60762,
		7,
		60762
	],
	"./id/_lib/formatRelative/index": [
		60762,
		7,
		60762
	],
	"./id/_lib/formatRelative/index.js": [
		60762,
		7,
		60762
	],
	"./id/_lib/localize": [
		75356,
		7,
		75356
	],
	"./id/_lib/localize/": [
		75356,
		7,
		75356
	],
	"./id/_lib/localize/index": [
		75356,
		7,
		75356
	],
	"./id/_lib/localize/index.js": [
		75356,
		7,
		75356
	],
	"./id/_lib/match": [
		3270,
		7,
		3270
	],
	"./id/_lib/match/": [
		3270,
		7,
		3270
	],
	"./id/_lib/match/index": [
		3270,
		7,
		3270
	],
	"./id/_lib/match/index.js": [
		3270,
		7,
		3270
	],
	"./id/index": [
		58937,
		7,
		58937
	],
	"./id/index.d": [
		32512,
		9,
		32512
	],
	"./id/index.d.ts": [
		32512,
		9,
		32512
	],
	"./id/index.js": [
		58937,
		7,
		58937
	],
	"./id/index.js.flow": [
		47723,
		7,
		47723
	],
	"./id/package": [
		56345,
		3,
		56345
	],
	"./id/package.json": [
		56345,
		3,
		56345
	],
	"./id/snapshot.md": [
		86041,
		7,
		86041
	],
	"./index": [
		10678,
		9,
		10678
	],
	"./index.js": [
		10678,
		9,
		10678
	],
	"./index.js.flow": [
		37831,
		7,
		37831
	],
	"./is": [
		88292,
		9,
		85534
	],
	"./is/": [
		88292,
		9,
		85534
	],
	"./is/_lib/formatDistance": [
		10574,
		7,
		90091
	],
	"./is/_lib/formatDistance/": [
		10574,
		7,
		90091
	],
	"./is/_lib/formatDistance/index": [
		10574,
		7,
		90091
	],
	"./is/_lib/formatDistance/index.js": [
		10574,
		7,
		90091
	],
	"./is/_lib/formatLong": [
		96164,
		7,
		96164
	],
	"./is/_lib/formatLong/": [
		96164,
		7,
		96164
	],
	"./is/_lib/formatLong/index": [
		96164,
		7,
		96164
	],
	"./is/_lib/formatLong/index.js": [
		96164,
		7,
		96164
	],
	"./is/_lib/formatRelative": [
		59252,
		7,
		59252
	],
	"./is/_lib/formatRelative/": [
		59252,
		7,
		59252
	],
	"./is/_lib/formatRelative/index": [
		59252,
		7,
		59252
	],
	"./is/_lib/formatRelative/index.js": [
		59252,
		7,
		59252
	],
	"./is/_lib/localize": [
		33755,
		7,
		33755
	],
	"./is/_lib/localize/": [
		33755,
		7,
		33755
	],
	"./is/_lib/localize/index": [
		33755,
		7,
		33755
	],
	"./is/_lib/localize/index.js": [
		33755,
		7,
		33755
	],
	"./is/_lib/match": [
		58328,
		7,
		58328
	],
	"./is/_lib/match/": [
		58328,
		7,
		58328
	],
	"./is/_lib/match/index": [
		58328,
		7,
		58328
	],
	"./is/_lib/match/index.js": [
		58328,
		7,
		58328
	],
	"./is/index": [
		95454,
		7,
		95454
	],
	"./is/index.d": [
		85534,
		9,
		85534
	],
	"./is/index.d.ts": [
		85534,
		9,
		85534
	],
	"./is/index.js": [
		95454,
		7,
		95454
	],
	"./is/index.js.flow": [
		48004,
		7,
		48004
	],
	"./is/package": [
		95775,
		3,
		95775
	],
	"./is/package.json": [
		95775,
		3,
		95775
	],
	"./is/snapshot.md": [
		20891,
		7,
		20891
	],
	"./it": [
		7992,
		9,
		72433
	],
	"./it/": [
		7992,
		9,
		72433
	],
	"./it/_lib/formatDistance": [
		47225,
		7,
		47225
	],
	"./it/_lib/formatDistance/": [
		47225,
		7,
		47225
	],
	"./it/_lib/formatDistance/index": [
		47225,
		7,
		47225
	],
	"./it/_lib/formatDistance/index.js": [
		47225,
		7,
		47225
	],
	"./it/_lib/formatLong": [
		61687,
		7,
		61687
	],
	"./it/_lib/formatLong/": [
		61687,
		7,
		61687
	],
	"./it/_lib/formatLong/index": [
		61687,
		7,
		61687
	],
	"./it/_lib/formatLong/index.js": [
		61687,
		7,
		61687
	],
	"./it/_lib/formatRelative": [
		84732,
		7,
		89566
	],
	"./it/_lib/formatRelative/": [
		84732,
		7,
		89566
	],
	"./it/_lib/formatRelative/index": [
		84732,
		7,
		89566
	],
	"./it/_lib/formatRelative/index.js": [
		84732,
		7,
		89566
	],
	"./it/_lib/localize": [
		72023,
		7,
		72023
	],
	"./it/_lib/localize/": [
		72023,
		7,
		72023
	],
	"./it/_lib/localize/index": [
		72023,
		7,
		72023
	],
	"./it/_lib/localize/index.js": [
		72023,
		7,
		72023
	],
	"./it/_lib/match": [
		27386,
		7,
		27386
	],
	"./it/_lib/match/": [
		27386,
		7,
		27386
	],
	"./it/_lib/match/index": [
		27386,
		7,
		27386
	],
	"./it/_lib/match/index.js": [
		27386,
		7,
		27386
	],
	"./it/index": [
		41659,
		7,
		41659
	],
	"./it/index.d": [
		72433,
		9,
		72433
	],
	"./it/index.d.ts": [
		72433,
		9,
		72433
	],
	"./it/index.js": [
		41659,
		7,
		41659
	],
	"./it/index.js.flow": [
		52431,
		7,
		52431
	],
	"./it/package": [
		6428,
		3,
		6428
	],
	"./it/package.json": [
		6428,
		3,
		6428
	],
	"./it/snapshot.md": [
		80188,
		7,
		80188
	],
	"./ja": [
		17219,
		9,
		58060
	],
	"./ja/": [
		17219,
		9,
		58060
	],
	"./ja/_lib/formatDistance": [
		22220,
		7,
		22220
	],
	"./ja/_lib/formatDistance/": [
		22220,
		7,
		22220
	],
	"./ja/_lib/formatDistance/index": [
		22220,
		7,
		22220
	],
	"./ja/_lib/formatDistance/index.js": [
		22220,
		7,
		22220
	],
	"./ja/_lib/formatLong": [
		69019,
		7,
		69019
	],
	"./ja/_lib/formatLong/": [
		69019,
		7,
		69019
	],
	"./ja/_lib/formatLong/index": [
		69019,
		7,
		69019
	],
	"./ja/_lib/formatLong/index.js": [
		69019,
		7,
		69019
	],
	"./ja/_lib/formatRelative": [
		13463,
		7,
		13463
	],
	"./ja/_lib/formatRelative/": [
		13463,
		7,
		13463
	],
	"./ja/_lib/formatRelative/index": [
		13463,
		7,
		13463
	],
	"./ja/_lib/formatRelative/index.js": [
		13463,
		7,
		13463
	],
	"./ja/_lib/localize": [
		84053,
		7,
		84053
	],
	"./ja/_lib/localize/": [
		84053,
		7,
		84053
	],
	"./ja/_lib/localize/index": [
		84053,
		7,
		84053
	],
	"./ja/_lib/localize/index.js": [
		84053,
		7,
		84053
	],
	"./ja/_lib/match": [
		70030,
		7,
		485
	],
	"./ja/_lib/match/": [
		70030,
		7,
		485
	],
	"./ja/_lib/match/index": [
		70030,
		7,
		485
	],
	"./ja/_lib/match/index.js": [
		70030,
		7,
		485
	],
	"./ja/index": [
		90927,
		7,
		90927
	],
	"./ja/index.d": [
		58060,
		9,
		58060
	],
	"./ja/index.d.ts": [
		58060,
		9,
		58060
	],
	"./ja/index.js": [
		90927,
		7,
		90927
	],
	"./ja/index.js.flow": [
		7012,
		7,
		7012
	],
	"./ja/package": [
		52913,
		3,
		52913
	],
	"./ja/package.json": [
		52913,
		3,
		52913
	],
	"./ja/snapshot.md": [
		2513,
		7,
		2513
	],
	"./ka": [
		9255,
		9,
		79444
	],
	"./ka/": [
		9255,
		9,
		79444
	],
	"./ka/_lib/formatDistance": [
		15152,
		7,
		15152
	],
	"./ka/_lib/formatDistance/": [
		15152,
		7,
		15152
	],
	"./ka/_lib/formatDistance/index": [
		15152,
		7,
		15152
	],
	"./ka/_lib/formatDistance/index.js": [
		15152,
		7,
		15152
	],
	"./ka/_lib/formatLong": [
		4787,
		7,
		4787
	],
	"./ka/_lib/formatLong/": [
		4787,
		7,
		4787
	],
	"./ka/_lib/formatLong/index": [
		4787,
		7,
		4787
	],
	"./ka/_lib/formatLong/index.js": [
		4787,
		7,
		4787
	],
	"./ka/_lib/formatRelative": [
		13456,
		7,
		13456
	],
	"./ka/_lib/formatRelative/": [
		13456,
		7,
		13456
	],
	"./ka/_lib/formatRelative/index": [
		13456,
		7,
		13456
	],
	"./ka/_lib/formatRelative/index.js": [
		13456,
		7,
		13456
	],
	"./ka/_lib/localize": [
		93130,
		7,
		93130
	],
	"./ka/_lib/localize/": [
		93130,
		7,
		93130
	],
	"./ka/_lib/localize/index": [
		93130,
		7,
		93130
	],
	"./ka/_lib/localize/index.js": [
		93130,
		7,
		93130
	],
	"./ka/_lib/match": [
		9964,
		7,
		9964
	],
	"./ka/_lib/match/": [
		9964,
		7,
		9964
	],
	"./ka/_lib/match/index": [
		9964,
		7,
		9964
	],
	"./ka/_lib/match/index.js": [
		9964,
		7,
		9964
	],
	"./ka/index": [
		56442,
		7,
		56442
	],
	"./ka/index.d": [
		79444,
		9,
		79444
	],
	"./ka/index.d.ts": [
		79444,
		9,
		79444
	],
	"./ka/index.js": [
		56442,
		7,
		56442
	],
	"./ka/index.js.flow": [
		1490,
		7,
		1490
	],
	"./ka/package": [
		89967,
		3,
		89967
	],
	"./ka/package.json": [
		89967,
		3,
		89967
	],
	"./ka/snapshot.md": [
		35735,
		7,
		35735
	],
	"./kk": [
		41741,
		9,
		25546
	],
	"./kk/": [
		41741,
		9,
		25546
	],
	"./kk/_lib/formatDistance": [
		96400,
		7,
		96400
	],
	"./kk/_lib/formatDistance/": [
		96400,
		7,
		96400
	],
	"./kk/_lib/formatDistance/index": [
		96400,
		7,
		96400
	],
	"./kk/_lib/formatDistance/index.js": [
		96400,
		7,
		96400
	],
	"./kk/_lib/formatLong": [
		94879,
		7,
		94879
	],
	"./kk/_lib/formatLong/": [
		94879,
		7,
		94879
	],
	"./kk/_lib/formatLong/index": [
		94879,
		7,
		94879
	],
	"./kk/_lib/formatLong/index.js": [
		94879,
		7,
		94879
	],
	"./kk/_lib/formatRelative": [
		99573,
		7,
		89566
	],
	"./kk/_lib/formatRelative/": [
		99573,
		7,
		89566
	],
	"./kk/_lib/formatRelative/index": [
		99573,
		7,
		89566
	],
	"./kk/_lib/formatRelative/index.js": [
		99573,
		7,
		89566
	],
	"./kk/_lib/localize": [
		47396,
		7,
		47396
	],
	"./kk/_lib/localize/": [
		47396,
		7,
		47396
	],
	"./kk/_lib/localize/index": [
		47396,
		7,
		47396
	],
	"./kk/_lib/localize/index.js": [
		47396,
		7,
		47396
	],
	"./kk/_lib/match": [
		19049,
		7,
		19049
	],
	"./kk/_lib/match/": [
		19049,
		7,
		19049
	],
	"./kk/_lib/match/index": [
		19049,
		7,
		19049
	],
	"./kk/_lib/match/index.js": [
		19049,
		7,
		19049
	],
	"./kk/index": [
		60232,
		7,
		55857
	],
	"./kk/index.d": [
		25546,
		9,
		25546
	],
	"./kk/index.d.ts": [
		25546,
		9,
		25546
	],
	"./kk/index.js": [
		60232,
		7,
		55857
	],
	"./kk/index.js.flow": [
		36973,
		7,
		36973
	],
	"./kk/package": [
		33421,
		3,
		33421
	],
	"./kk/package.json": [
		33421,
		3,
		33421
	],
	"./kk/snapshot.md": [
		25827,
		7,
		25827
	],
	"./kn": [
		51677,
		9,
		70276
	],
	"./kn/": [
		51677,
		9,
		70276
	],
	"./kn/_lib/formatDistance": [
		72541,
		7,
		72541
	],
	"./kn/_lib/formatDistance/": [
		72541,
		7,
		72541
	],
	"./kn/_lib/formatDistance/index": [
		72541,
		7,
		72541
	],
	"./kn/_lib/formatDistance/index.js": [
		72541,
		7,
		72541
	],
	"./kn/_lib/formatLong": [
		48833,
		7,
		48833
	],
	"./kn/_lib/formatLong/": [
		48833,
		7,
		48833
	],
	"./kn/_lib/formatLong/index": [
		48833,
		7,
		48833
	],
	"./kn/_lib/formatLong/index.js": [
		48833,
		7,
		48833
	],
	"./kn/_lib/formatRelative": [
		69117,
		7,
		69117
	],
	"./kn/_lib/formatRelative/": [
		69117,
		7,
		69117
	],
	"./kn/_lib/formatRelative/index": [
		69117,
		7,
		69117
	],
	"./kn/_lib/formatRelative/index.js": [
		69117,
		7,
		69117
	],
	"./kn/_lib/localize": [
		92235,
		7,
		92235
	],
	"./kn/_lib/localize/": [
		92235,
		7,
		92235
	],
	"./kn/_lib/localize/index": [
		92235,
		7,
		92235
	],
	"./kn/_lib/localize/index.js": [
		92235,
		7,
		92235
	],
	"./kn/_lib/match": [
		64679,
		7,
		64679
	],
	"./kn/_lib/match/": [
		64679,
		7,
		64679
	],
	"./kn/_lib/match/index": [
		64679,
		7,
		64679
	],
	"./kn/_lib/match/index.js": [
		64679,
		7,
		64679
	],
	"./kn/index": [
		52042,
		7,
		52042
	],
	"./kn/index.d": [
		70276,
		9,
		70276
	],
	"./kn/index.d.ts": [
		70276,
		9,
		70276
	],
	"./kn/index.js": [
		52042,
		7,
		52042
	],
	"./kn/index.js.flow": [
		76012,
		7,
		76012
	],
	"./kn/package": [
		87047,
		3,
		87047
	],
	"./kn/package.json": [
		87047,
		3,
		87047
	],
	"./kn/snapshot.md": [
		29908,
		7,
		29908
	],
	"./ko": [
		91358,
		9,
		58187
	],
	"./ko/": [
		91358,
		9,
		58187
	],
	"./ko/_lib/formatDistance": [
		15091,
		7,
		15091
	],
	"./ko/_lib/formatDistance/": [
		15091,
		7,
		15091
	],
	"./ko/_lib/formatDistance/index": [
		15091,
		7,
		15091
	],
	"./ko/_lib/formatDistance/index.js": [
		15091,
		7,
		15091
	],
	"./ko/_lib/formatLong": [
		76767,
		7,
		76767
	],
	"./ko/_lib/formatLong/": [
		76767,
		7,
		76767
	],
	"./ko/_lib/formatLong/index": [
		76767,
		7,
		76767
	],
	"./ko/_lib/formatLong/index.js": [
		76767,
		7,
		76767
	],
	"./ko/_lib/formatRelative": [
		48555,
		7,
		48555
	],
	"./ko/_lib/formatRelative/": [
		48555,
		7,
		48555
	],
	"./ko/_lib/formatRelative/index": [
		48555,
		7,
		48555
	],
	"./ko/_lib/formatRelative/index.js": [
		48555,
		7,
		48555
	],
	"./ko/_lib/localize": [
		72442,
		7,
		72442
	],
	"./ko/_lib/localize/": [
		72442,
		7,
		72442
	],
	"./ko/_lib/localize/index": [
		72442,
		7,
		72442
	],
	"./ko/_lib/localize/index.js": [
		72442,
		7,
		72442
	],
	"./ko/_lib/match": [
		11965,
		7,
		11965
	],
	"./ko/_lib/match/": [
		11965,
		7,
		11965
	],
	"./ko/_lib/match/index": [
		11965,
		7,
		11965
	],
	"./ko/_lib/match/index.js": [
		11965,
		7,
		11965
	],
	"./ko/index": [
		85431,
		7,
		85431
	],
	"./ko/index.d": [
		58187,
		9,
		58187
	],
	"./ko/index.d.ts": [
		58187,
		9,
		58187
	],
	"./ko/index.js": [
		85431,
		7,
		85431
	],
	"./ko/index.js.flow": [
		48758,
		7,
		48758
	],
	"./ko/package": [
		80232,
		3,
		80232
	],
	"./ko/package.json": [
		80232,
		3,
		80232
	],
	"./ko/snapshot.md": [
		90935,
		7,
		90935
	],
	"./lt": [
		40247,
		9,
		1753
	],
	"./lt/": [
		40247,
		9,
		1753
	],
	"./lt/_lib/formatDistance": [
		74254,
		7,
		74254
	],
	"./lt/_lib/formatDistance/": [
		74254,
		7,
		74254
	],
	"./lt/_lib/formatDistance/index": [
		74254,
		7,
		74254
	],
	"./lt/_lib/formatDistance/index.js": [
		74254,
		7,
		74254
	],
	"./lt/_lib/formatLong": [
		48323,
		7,
		48323
	],
	"./lt/_lib/formatLong/": [
		48323,
		7,
		48323
	],
	"./lt/_lib/formatLong/index": [
		48323,
		7,
		48323
	],
	"./lt/_lib/formatLong/index.js": [
		48323,
		7,
		48323
	],
	"./lt/_lib/formatRelative": [
		5455,
		7,
		5455
	],
	"./lt/_lib/formatRelative/": [
		5455,
		7,
		5455
	],
	"./lt/_lib/formatRelative/index": [
		5455,
		7,
		5455
	],
	"./lt/_lib/formatRelative/index.js": [
		5455,
		7,
		5455
	],
	"./lt/_lib/localize": [
		6263,
		7,
		6263
	],
	"./lt/_lib/localize/": [
		6263,
		7,
		6263
	],
	"./lt/_lib/localize/index": [
		6263,
		7,
		6263
	],
	"./lt/_lib/localize/index.js": [
		6263,
		7,
		6263
	],
	"./lt/_lib/match": [
		71043,
		7,
		71043
	],
	"./lt/_lib/match/": [
		71043,
		7,
		71043
	],
	"./lt/_lib/match/index": [
		71043,
		7,
		71043
	],
	"./lt/_lib/match/index.js": [
		71043,
		7,
		71043
	],
	"./lt/index": [
		29512,
		7,
		29512
	],
	"./lt/index.d": [
		1753,
		9,
		1753
	],
	"./lt/index.d.ts": [
		1753,
		9,
		1753
	],
	"./lt/index.js": [
		29512,
		7,
		29512
	],
	"./lt/index.js.flow": [
		94936,
		7,
		94936
	],
	"./lt/package": [
		27944,
		3,
		27944
	],
	"./lt/package.json": [
		27944,
		3,
		27944
	],
	"./lt/snapshot.md": [
		75023,
		7,
		75023
	],
	"./lv": [
		54482,
		9,
		47758
	],
	"./lv/": [
		54482,
		9,
		47758
	],
	"./lv/_lib/formatDistance": [
		13587,
		7,
		13587
	],
	"./lv/_lib/formatDistance/": [
		13587,
		7,
		13587
	],
	"./lv/_lib/formatDistance/index": [
		13587,
		7,
		13587
	],
	"./lv/_lib/formatDistance/index.js": [
		13587,
		7,
		13587
	],
	"./lv/_lib/formatLong": [
		80077,
		7,
		80077
	],
	"./lv/_lib/formatLong/": [
		80077,
		7,
		80077
	],
	"./lv/_lib/formatLong/index": [
		80077,
		7,
		80077
	],
	"./lv/_lib/formatLong/index.js": [
		80077,
		7,
		80077
	],
	"./lv/_lib/formatRelative": [
		56467,
		7,
		65922
	],
	"./lv/_lib/formatRelative/": [
		56467,
		7,
		65922
	],
	"./lv/_lib/formatRelative/index": [
		56467,
		7,
		65922
	],
	"./lv/_lib/formatRelative/index.js": [
		56467,
		7,
		65922
	],
	"./lv/_lib/localize": [
		60113,
		7,
		60113
	],
	"./lv/_lib/localize/": [
		60113,
		7,
		60113
	],
	"./lv/_lib/localize/index": [
		60113,
		7,
		60113
	],
	"./lv/_lib/localize/index.js": [
		60113,
		7,
		60113
	],
	"./lv/_lib/match": [
		63312,
		7,
		63312
	],
	"./lv/_lib/match/": [
		63312,
		7,
		63312
	],
	"./lv/_lib/match/index": [
		63312,
		7,
		63312
	],
	"./lv/_lib/match/index.js": [
		63312,
		7,
		63312
	],
	"./lv/index": [
		86119,
		7,
		86119
	],
	"./lv/index.d": [
		47758,
		9,
		47758
	],
	"./lv/index.d.ts": [
		47758,
		9,
		47758
	],
	"./lv/index.js": [
		86119,
		7,
		86119
	],
	"./lv/index.js.flow": [
		17651,
		7,
		17651
	],
	"./lv/package": [
		28322,
		3,
		28322
	],
	"./lv/package.json": [
		28322,
		3,
		28322
	],
	"./lv/snapshot.md": [
		93687,
		7,
		93687
	],
	"./mk": [
		18223,
		9,
		84548
	],
	"./mk/": [
		18223,
		9,
		84548
	],
	"./mk/_lib/formatDistance": [
		14184,
		7,
		47726
	],
	"./mk/_lib/formatDistance/": [
		14184,
		7,
		47726
	],
	"./mk/_lib/formatDistance/index": [
		14184,
		7,
		47726
	],
	"./mk/_lib/formatDistance/index.js": [
		14184,
		7,
		47726
	],
	"./mk/_lib/formatLong": [
		82737,
		7,
		82737
	],
	"./mk/_lib/formatLong/": [
		82737,
		7,
		82737
	],
	"./mk/_lib/formatLong/index": [
		82737,
		7,
		82737
	],
	"./mk/_lib/formatLong/index.js": [
		82737,
		7,
		82737
	],
	"./mk/_lib/formatRelative": [
		83864,
		7,
		8669
	],
	"./mk/_lib/formatRelative/": [
		83864,
		7,
		8669
	],
	"./mk/_lib/formatRelative/index": [
		83864,
		7,
		8669
	],
	"./mk/_lib/formatRelative/index.js": [
		83864,
		7,
		8669
	],
	"./mk/_lib/localize": [
		95565,
		7,
		95565
	],
	"./mk/_lib/localize/": [
		95565,
		7,
		95565
	],
	"./mk/_lib/localize/index": [
		95565,
		7,
		95565
	],
	"./mk/_lib/localize/index.js": [
		95565,
		7,
		95565
	],
	"./mk/_lib/match": [
		1450,
		7,
		1450
	],
	"./mk/_lib/match/": [
		1450,
		7,
		1450
	],
	"./mk/_lib/match/index": [
		1450,
		7,
		1450
	],
	"./mk/_lib/match/index.js": [
		1450,
		7,
		1450
	],
	"./mk/index": [
		40605,
		7,
		40605
	],
	"./mk/index.d": [
		84548,
		9,
		84548
	],
	"./mk/index.d.ts": [
		84548,
		9,
		84548
	],
	"./mk/index.js": [
		40605,
		7,
		40605
	],
	"./mk/index.js.flow": [
		34693,
		7,
		34693
	],
	"./mk/package": [
		25845,
		3,
		25845
	],
	"./mk/package.json": [
		25845,
		3,
		25845
	],
	"./mk/snapshot.md": [
		70386,
		7,
		70386
	],
	"./ms": [
		30945,
		9,
		50287
	],
	"./ms/": [
		30945,
		9,
		50287
	],
	"./ms/_lib/formatDistance": [
		21142,
		7,
		21142
	],
	"./ms/_lib/formatDistance/": [
		21142,
		7,
		21142
	],
	"./ms/_lib/formatDistance/index": [
		21142,
		7,
		21142
	],
	"./ms/_lib/formatDistance/index.js": [
		21142,
		7,
		21142
	],
	"./ms/_lib/formatLong": [
		16090,
		7,
		16090
	],
	"./ms/_lib/formatLong/": [
		16090,
		7,
		16090
	],
	"./ms/_lib/formatLong/index": [
		16090,
		7,
		16090
	],
	"./ms/_lib/formatLong/index.js": [
		16090,
		7,
		16090
	],
	"./ms/_lib/formatRelative": [
		85188,
		7,
		85188
	],
	"./ms/_lib/formatRelative/": [
		85188,
		7,
		85188
	],
	"./ms/_lib/formatRelative/index": [
		85188,
		7,
		85188
	],
	"./ms/_lib/formatRelative/index.js": [
		85188,
		7,
		85188
	],
	"./ms/_lib/localize": [
		67481,
		7,
		67481
	],
	"./ms/_lib/localize/": [
		67481,
		7,
		67481
	],
	"./ms/_lib/localize/index": [
		67481,
		7,
		67481
	],
	"./ms/_lib/localize/index.js": [
		67481,
		7,
		67481
	],
	"./ms/_lib/match": [
		43443,
		7,
		43443
	],
	"./ms/_lib/match/": [
		43443,
		7,
		43443
	],
	"./ms/_lib/match/index": [
		43443,
		7,
		43443
	],
	"./ms/_lib/match/index.js": [
		43443,
		7,
		43443
	],
	"./ms/index": [
		40902,
		7,
		40902
	],
	"./ms/index.d": [
		50287,
		9,
		50287
	],
	"./ms/index.d.ts": [
		50287,
		9,
		50287
	],
	"./ms/index.js": [
		40902,
		7,
		40902
	],
	"./ms/index.js.flow": [
		41131,
		7,
		41131
	],
	"./ms/package": [
		47126,
		3,
		47126
	],
	"./ms/package.json": [
		47126,
		3,
		47126
	],
	"./ms/snapshot.md": [
		2966,
		7,
		2966
	],
	"./mt": [
		1248,
		9,
		357
	],
	"./mt/": [
		1248,
		9,
		357
	],
	"./mt/_lib/formatDistance": [
		90640,
		7,
		90640
	],
	"./mt/_lib/formatDistance/": [
		90640,
		7,
		90640
	],
	"./mt/_lib/formatDistance/index": [
		90640,
		7,
		90640
	],
	"./mt/_lib/formatDistance/index.js": [
		90640,
		7,
		90640
	],
	"./mt/_lib/formatLong": [
		1791,
		7,
		1791
	],
	"./mt/_lib/formatLong/": [
		1791,
		7,
		1791
	],
	"./mt/_lib/formatLong/index": [
		1791,
		7,
		1791
	],
	"./mt/_lib/formatLong/index.js": [
		1791,
		7,
		1791
	],
	"./mt/_lib/formatRelative": [
		21123,
		7,
		21123
	],
	"./mt/_lib/formatRelative/": [
		21123,
		7,
		21123
	],
	"./mt/_lib/formatRelative/index": [
		21123,
		7,
		21123
	],
	"./mt/_lib/formatRelative/index.js": [
		21123,
		7,
		21123
	],
	"./mt/_lib/localize": [
		64260,
		7,
		64260
	],
	"./mt/_lib/localize/": [
		64260,
		7,
		64260
	],
	"./mt/_lib/localize/index": [
		64260,
		7,
		64260
	],
	"./mt/_lib/localize/index.js": [
		64260,
		7,
		64260
	],
	"./mt/_lib/match": [
		8440,
		7,
		8440
	],
	"./mt/_lib/match/": [
		8440,
		7,
		8440
	],
	"./mt/_lib/match/index": [
		8440,
		7,
		8440
	],
	"./mt/_lib/match/index.js": [
		8440,
		7,
		8440
	],
	"./mt/index": [
		98980,
		7,
		98980
	],
	"./mt/index.d": [
		357,
		9,
		357
	],
	"./mt/index.d.ts": [
		357,
		9,
		357
	],
	"./mt/index.js": [
		98980,
		7,
		98980
	],
	"./mt/index.js.flow": [
		87269,
		7,
		87269
	],
	"./mt/package": [
		77396,
		3,
		77396
	],
	"./mt/package.json": [
		77396,
		3,
		77396
	],
	"./mt/snapshot.md": [
		42471,
		7,
		42471
	],
	"./nb": [
		25320,
		9,
		39655
	],
	"./nb/": [
		25320,
		9,
		39655
	],
	"./nb/_lib/formatDistance": [
		70364,
		7,
		70364
	],
	"./nb/_lib/formatDistance/": [
		70364,
		7,
		70364
	],
	"./nb/_lib/formatDistance/index": [
		70364,
		7,
		70364
	],
	"./nb/_lib/formatDistance/index.js": [
		70364,
		7,
		70364
	],
	"./nb/_lib/formatLong": [
		77246,
		7,
		77246
	],
	"./nb/_lib/formatLong/": [
		77246,
		7,
		77246
	],
	"./nb/_lib/formatLong/index": [
		77246,
		7,
		77246
	],
	"./nb/_lib/formatLong/index.js": [
		77246,
		7,
		77246
	],
	"./nb/_lib/formatRelative": [
		44229,
		7,
		44229
	],
	"./nb/_lib/formatRelative/": [
		44229,
		7,
		44229
	],
	"./nb/_lib/formatRelative/index": [
		44229,
		7,
		44229
	],
	"./nb/_lib/formatRelative/index.js": [
		44229,
		7,
		44229
	],
	"./nb/_lib/localize": [
		41730,
		7,
		41730
	],
	"./nb/_lib/localize/": [
		41730,
		7,
		41730
	],
	"./nb/_lib/localize/index": [
		41730,
		7,
		41730
	],
	"./nb/_lib/localize/index.js": [
		41730,
		7,
		41730
	],
	"./nb/_lib/match": [
		1046,
		7,
		1046
	],
	"./nb/_lib/match/": [
		1046,
		7,
		1046
	],
	"./nb/_lib/match/index": [
		1046,
		7,
		1046
	],
	"./nb/_lib/match/index.js": [
		1046,
		7,
		1046
	],
	"./nb/index": [
		75526,
		7,
		75526
	],
	"./nb/index.d": [
		39655,
		9,
		39655
	],
	"./nb/index.d.ts": [
		39655,
		9,
		39655
	],
	"./nb/index.js": [
		75526,
		7,
		75526
	],
	"./nb/index.js.flow": [
		22172,
		7,
		22172
	],
	"./nb/package": [
		1507,
		3,
		1507
	],
	"./nb/package.json": [
		1507,
		3,
		1507
	],
	"./nb/snapshot.md": [
		89906,
		7,
		89906
	],
	"./nl": [
		61937,
		9,
		54829
	],
	"./nl-BE": [
		11703,
		9,
		66428
	],
	"./nl-BE/": [
		11703,
		9,
		66428
	],
	"./nl-BE/_lib/formatDistance": [
		49873,
		7,
		49873
	],
	"./nl-BE/_lib/formatDistance/": [
		49873,
		7,
		49873
	],
	"./nl-BE/_lib/formatDistance/index": [
		49873,
		7,
		49873
	],
	"./nl-BE/_lib/formatDistance/index.js": [
		49873,
		7,
		49873
	],
	"./nl-BE/_lib/formatLong": [
		48266,
		7,
		48266
	],
	"./nl-BE/_lib/formatLong/": [
		48266,
		7,
		48266
	],
	"./nl-BE/_lib/formatLong/index": [
		48266,
		7,
		48266
	],
	"./nl-BE/_lib/formatLong/index.js": [
		48266,
		7,
		48266
	],
	"./nl-BE/_lib/formatRelative": [
		70754,
		7,
		70754
	],
	"./nl-BE/_lib/formatRelative/": [
		70754,
		7,
		70754
	],
	"./nl-BE/_lib/formatRelative/index": [
		70754,
		7,
		70754
	],
	"./nl-BE/_lib/formatRelative/index.js": [
		70754,
		7,
		70754
	],
	"./nl-BE/_lib/localize": [
		74251,
		7,
		74251
	],
	"./nl-BE/_lib/localize/": [
		74251,
		7,
		74251
	],
	"./nl-BE/_lib/localize/index": [
		74251,
		7,
		74251
	],
	"./nl-BE/_lib/localize/index.js": [
		74251,
		7,
		74251
	],
	"./nl-BE/_lib/match": [
		3759,
		7,
		3759
	],
	"./nl-BE/_lib/match/": [
		3759,
		7,
		3759
	],
	"./nl-BE/_lib/match/index": [
		3759,
		7,
		3759
	],
	"./nl-BE/_lib/match/index.js": [
		3759,
		7,
		3759
	],
	"./nl-BE/index": [
		21308,
		7,
		21308
	],
	"./nl-BE/index.d": [
		66428,
		9,
		66428
	],
	"./nl-BE/index.d.ts": [
		66428,
		9,
		66428
	],
	"./nl-BE/index.js": [
		21308,
		7,
		21308
	],
	"./nl-BE/index.js.flow": [
		80846,
		7,
		80846
	],
	"./nl-BE/package": [
		93662,
		3,
		93662
	],
	"./nl-BE/package.json": [
		93662,
		3,
		93662
	],
	"./nl-BE/snapshot.md": [
		21704,
		7,
		21704
	],
	"./nl/": [
		61937,
		9,
		54829
	],
	"./nl/_lib/formatDistance": [
		67876,
		7,
		67876
	],
	"./nl/_lib/formatDistance/": [
		67876,
		7,
		67876
	],
	"./nl/_lib/formatDistance/index": [
		67876,
		7,
		67876
	],
	"./nl/_lib/formatDistance/index.js": [
		67876,
		7,
		67876
	],
	"./nl/_lib/formatLong": [
		4244,
		7,
		4244
	],
	"./nl/_lib/formatLong/": [
		4244,
		7,
		4244
	],
	"./nl/_lib/formatLong/index": [
		4244,
		7,
		4244
	],
	"./nl/_lib/formatLong/index.js": [
		4244,
		7,
		4244
	],
	"./nl/_lib/formatRelative": [
		41891,
		7,
		41891
	],
	"./nl/_lib/formatRelative/": [
		41891,
		7,
		41891
	],
	"./nl/_lib/formatRelative/index": [
		41891,
		7,
		41891
	],
	"./nl/_lib/formatRelative/index.js": [
		41891,
		7,
		41891
	],
	"./nl/_lib/localize": [
		30050,
		7,
		30050
	],
	"./nl/_lib/localize/": [
		30050,
		7,
		30050
	],
	"./nl/_lib/localize/index": [
		30050,
		7,
		30050
	],
	"./nl/_lib/localize/index.js": [
		30050,
		7,
		30050
	],
	"./nl/_lib/match": [
		806,
		7,
		806
	],
	"./nl/_lib/match/": [
		806,
		7,
		806
	],
	"./nl/_lib/match/index": [
		806,
		7,
		806
	],
	"./nl/_lib/match/index.js": [
		806,
		7,
		806
	],
	"./nl/index": [
		633,
		7,
		633
	],
	"./nl/index.d": [
		54829,
		9,
		54829
	],
	"./nl/index.d.ts": [
		54829,
		9,
		54829
	],
	"./nl/index.js": [
		633,
		7,
		633
	],
	"./nl/index.js.flow": [
		45058,
		7,
		45058
	],
	"./nl/package": [
		28510,
		3,
		28510
	],
	"./nl/package.json": [
		28510,
		3,
		28510
	],
	"./nl/snapshot.md": [
		91282,
		7,
		91282
	],
	"./nn": [
		46915,
		9,
		15369
	],
	"./nn/": [
		46915,
		9,
		15369
	],
	"./nn/_lib/formatDistance": [
		72086,
		7,
		72086
	],
	"./nn/_lib/formatDistance/": [
		72086,
		7,
		72086
	],
	"./nn/_lib/formatDistance/index": [
		72086,
		7,
		72086
	],
	"./nn/_lib/formatDistance/index.js": [
		72086,
		7,
		72086
	],
	"./nn/_lib/formatLong": [
		18475,
		7,
		18475
	],
	"./nn/_lib/formatLong/": [
		18475,
		7,
		18475
	],
	"./nn/_lib/formatLong/index": [
		18475,
		7,
		18475
	],
	"./nn/_lib/formatLong/index.js": [
		18475,
		7,
		18475
	],
	"./nn/_lib/formatRelative": [
		74330,
		7,
		74330
	],
	"./nn/_lib/formatRelative/": [
		74330,
		7,
		74330
	],
	"./nn/_lib/formatRelative/index": [
		74330,
		7,
		74330
	],
	"./nn/_lib/formatRelative/index.js": [
		74330,
		7,
		74330
	],
	"./nn/_lib/localize": [
		28393,
		7,
		28393
	],
	"./nn/_lib/localize/": [
		28393,
		7,
		28393
	],
	"./nn/_lib/localize/index": [
		28393,
		7,
		28393
	],
	"./nn/_lib/localize/index.js": [
		28393,
		7,
		28393
	],
	"./nn/_lib/match": [
		10102,
		7,
		10102
	],
	"./nn/_lib/match/": [
		10102,
		7,
		10102
	],
	"./nn/_lib/match/index": [
		10102,
		7,
		10102
	],
	"./nn/_lib/match/index.js": [
		10102,
		7,
		10102
	],
	"./nn/index": [
		94386,
		7,
		94386
	],
	"./nn/index.d": [
		15369,
		9,
		15369
	],
	"./nn/index.d.ts": [
		15369,
		9,
		15369
	],
	"./nn/index.js": [
		94386,
		7,
		94386
	],
	"./nn/index.js.flow": [
		18357,
		7,
		18357
	],
	"./nn/package": [
		59926,
		3,
		59926
	],
	"./nn/package.json": [
		59926,
		3,
		59926
	],
	"./nn/snapshot.md": [
		28940,
		7,
		28940
	],
	"./package": [
		83179,
		3,
		83179
	],
	"./package.json": [
		83179,
		3,
		83179
	],
	"./pl": [
		68079,
		9,
		54487
	],
	"./pl/": [
		68079,
		9,
		54487
	],
	"./pl/_lib/formatDistance": [
		59237,
		7,
		59237
	],
	"./pl/_lib/formatDistance/": [
		59237,
		7,
		59237
	],
	"./pl/_lib/formatDistance/index": [
		59237,
		7,
		59237
	],
	"./pl/_lib/formatDistance/index.js": [
		59237,
		7,
		59237
	],
	"./pl/_lib/formatLong": [
		64148,
		7,
		64148
	],
	"./pl/_lib/formatLong/": [
		64148,
		7,
		64148
	],
	"./pl/_lib/formatLong/index": [
		64148,
		7,
		64148
	],
	"./pl/_lib/formatLong/index.js": [
		64148,
		7,
		64148
	],
	"./pl/_lib/formatRelative": [
		97717,
		7,
		23162
	],
	"./pl/_lib/formatRelative/": [
		97717,
		7,
		23162
	],
	"./pl/_lib/formatRelative/index": [
		97717,
		7,
		23162
	],
	"./pl/_lib/formatRelative/index.js": [
		97717,
		7,
		23162
	],
	"./pl/_lib/localize": [
		12308,
		7,
		12308
	],
	"./pl/_lib/localize/": [
		12308,
		7,
		12308
	],
	"./pl/_lib/localize/index": [
		12308,
		7,
		12308
	],
	"./pl/_lib/localize/index.js": [
		12308,
		7,
		12308
	],
	"./pl/_lib/match": [
		26389,
		7,
		26389
	],
	"./pl/_lib/match/": [
		26389,
		7,
		26389
	],
	"./pl/_lib/match/index": [
		26389,
		7,
		26389
	],
	"./pl/_lib/match/index.js": [
		26389,
		7,
		26389
	],
	"./pl/index": [
		50838,
		7,
		50838
	],
	"./pl/index.d": [
		54487,
		9,
		54487
	],
	"./pl/index.d.ts": [
		54487,
		9,
		54487
	],
	"./pl/index.js": [
		50838,
		7,
		50838
	],
	"./pl/index.js.flow": [
		89598,
		7,
		89598
	],
	"./pl/package": [
		61880,
		3,
		61880
	],
	"./pl/package.json": [
		61880,
		3,
		61880
	],
	"./pl/snapshot.md": [
		87468,
		7,
		87468
	],
	"./pt": [
		11286,
		9,
		30524
	],
	"./pt-BR": [
		61210,
		9,
		47883
	],
	"./pt-BR/": [
		61210,
		9,
		47883
	],
	"./pt-BR/_lib/formatDistance": [
		45002,
		7,
		45002
	],
	"./pt-BR/_lib/formatDistance/": [
		45002,
		7,
		45002
	],
	"./pt-BR/_lib/formatDistance/index": [
		45002,
		7,
		45002
	],
	"./pt-BR/_lib/formatDistance/index.js": [
		45002,
		7,
		45002
	],
	"./pt-BR/_lib/formatLong": [
		90221,
		7,
		90221
	],
	"./pt-BR/_lib/formatLong/": [
		90221,
		7,
		90221
	],
	"./pt-BR/_lib/formatLong/index": [
		90221,
		7,
		90221
	],
	"./pt-BR/_lib/formatLong/index.js": [
		90221,
		7,
		90221
	],
	"./pt-BR/_lib/formatRelative": [
		20040,
		7,
		20040
	],
	"./pt-BR/_lib/formatRelative/": [
		20040,
		7,
		20040
	],
	"./pt-BR/_lib/formatRelative/index": [
		20040,
		7,
		20040
	],
	"./pt-BR/_lib/formatRelative/index.js": [
		20040,
		7,
		20040
	],
	"./pt-BR/_lib/localize": [
		86361,
		7,
		86361
	],
	"./pt-BR/_lib/localize/": [
		86361,
		7,
		86361
	],
	"./pt-BR/_lib/localize/index": [
		86361,
		7,
		86361
	],
	"./pt-BR/_lib/localize/index.js": [
		86361,
		7,
		86361
	],
	"./pt-BR/_lib/match": [
		5105,
		7,
		5105
	],
	"./pt-BR/_lib/match/": [
		5105,
		7,
		5105
	],
	"./pt-BR/_lib/match/index": [
		5105,
		7,
		5105
	],
	"./pt-BR/_lib/match/index.js": [
		5105,
		7,
		5105
	],
	"./pt-BR/index": [
		12171,
		7,
		12171
	],
	"./pt-BR/index.d": [
		47883,
		9,
		47883
	],
	"./pt-BR/index.d.ts": [
		47883,
		9,
		47883
	],
	"./pt-BR/index.js": [
		12171,
		7,
		12171
	],
	"./pt-BR/index.js.flow": [
		90209,
		7,
		90209
	],
	"./pt-BR/package": [
		27960,
		3,
		27960
	],
	"./pt-BR/package.json": [
		27960,
		3,
		27960
	],
	"./pt-BR/snapshot.md": [
		82130,
		7,
		82130
	],
	"./pt/": [
		11286,
		9,
		30524
	],
	"./pt/_lib/formatDistance": [
		7274,
		7,
		7274
	],
	"./pt/_lib/formatDistance/": [
		7274,
		7,
		7274
	],
	"./pt/_lib/formatDistance/index": [
		7274,
		7,
		7274
	],
	"./pt/_lib/formatDistance/index.js": [
		7274,
		7,
		7274
	],
	"./pt/_lib/formatLong": [
		27892,
		7,
		27892
	],
	"./pt/_lib/formatLong/": [
		27892,
		7,
		27892
	],
	"./pt/_lib/formatLong/index": [
		27892,
		7,
		27892
	],
	"./pt/_lib/formatLong/index.js": [
		27892,
		7,
		27892
	],
	"./pt/_lib/formatRelative": [
		62522,
		7,
		62522
	],
	"./pt/_lib/formatRelative/": [
		62522,
		7,
		62522
	],
	"./pt/_lib/formatRelative/index": [
		62522,
		7,
		62522
	],
	"./pt/_lib/formatRelative/index.js": [
		62522,
		7,
		62522
	],
	"./pt/_lib/localize": [
		26358,
		7,
		70098
	],
	"./pt/_lib/localize/": [
		26358,
		7,
		70098
	],
	"./pt/_lib/localize/index": [
		26358,
		7,
		70098
	],
	"./pt/_lib/localize/index.js": [
		26358,
		7,
		70098
	],
	"./pt/_lib/match": [
		7103,
		7,
		7103
	],
	"./pt/_lib/match/": [
		7103,
		7,
		7103
	],
	"./pt/_lib/match/index": [
		7103,
		7,
		7103
	],
	"./pt/_lib/match/index.js": [
		7103,
		7,
		7103
	],
	"./pt/index": [
		14723,
		7,
		14723
	],
	"./pt/index.d": [
		30524,
		9,
		30524
	],
	"./pt/index.d.ts": [
		30524,
		9,
		30524
	],
	"./pt/index.js": [
		14723,
		7,
		14723
	],
	"./pt/index.js.flow": [
		6041,
		7,
		6041
	],
	"./pt/package": [
		85066,
		3,
		85066
	],
	"./pt/package.json": [
		85066,
		3,
		85066
	],
	"./pt/snapshot.md": [
		43827,
		7,
		72978
	],
	"./ro": [
		76365,
		9,
		67970
	],
	"./ro/": [
		76365,
		9,
		67970
	],
	"./ro/_lib/formatDistance": [
		50709,
		7,
		50709
	],
	"./ro/_lib/formatDistance/": [
		50709,
		7,
		50709
	],
	"./ro/_lib/formatDistance/index": [
		50709,
		7,
		50709
	],
	"./ro/_lib/formatDistance/index.js": [
		50709,
		7,
		50709
	],
	"./ro/_lib/formatLong": [
		40853,
		7,
		40853
	],
	"./ro/_lib/formatLong/": [
		40853,
		7,
		40853
	],
	"./ro/_lib/formatLong/index": [
		40853,
		7,
		40853
	],
	"./ro/_lib/formatLong/index.js": [
		40853,
		7,
		40853
	],
	"./ro/_lib/formatRelative": [
		53622,
		7,
		18345
	],
	"./ro/_lib/formatRelative/": [
		53622,
		7,
		18345
	],
	"./ro/_lib/formatRelative/index": [
		53622,
		7,
		18345
	],
	"./ro/_lib/formatRelative/index.js": [
		53622,
		7,
		18345
	],
	"./ro/_lib/localize": [
		98456,
		7,
		98456
	],
	"./ro/_lib/localize/": [
		98456,
		7,
		98456
	],
	"./ro/_lib/localize/index": [
		98456,
		7,
		98456
	],
	"./ro/_lib/localize/index.js": [
		98456,
		7,
		98456
	],
	"./ro/_lib/match": [
		55536,
		7,
		55536
	],
	"./ro/_lib/match/": [
		55536,
		7,
		55536
	],
	"./ro/_lib/match/index": [
		55536,
		7,
		55536
	],
	"./ro/_lib/match/index.js": [
		55536,
		7,
		55536
	],
	"./ro/index": [
		85315,
		7,
		85315
	],
	"./ro/index.d": [
		67970,
		9,
		67970
	],
	"./ro/index.d.ts": [
		67970,
		9,
		67970
	],
	"./ro/index.js": [
		85315,
		7,
		85315
	],
	"./ro/index.js.flow": [
		37350,
		7,
		37350
	],
	"./ro/package": [
		66543,
		3,
		66543
	],
	"./ro/package.json": [
		66543,
		3,
		66543
	],
	"./ro/snapshot.md": [
		19982,
		7,
		19982
	],
	"./ru": [
		32045,
		9,
		5601
	],
	"./ru/": [
		32045,
		9,
		5601
	],
	"./ru/_lib/formatDistance": [
		45651,
		7,
		45651
	],
	"./ru/_lib/formatDistance/": [
		45651,
		7,
		45651
	],
	"./ru/_lib/formatDistance/index": [
		45651,
		7,
		45651
	],
	"./ru/_lib/formatDistance/index.js": [
		45651,
		7,
		45651
	],
	"./ru/_lib/formatLong": [
		15664,
		7,
		15664
	],
	"./ru/_lib/formatLong/": [
		15664,
		7,
		15664
	],
	"./ru/_lib/formatLong/index": [
		15664,
		7,
		15664
	],
	"./ru/_lib/formatLong/index.js": [
		15664,
		7,
		15664
	],
	"./ru/_lib/formatRelative": [
		4015,
		7,
		65922
	],
	"./ru/_lib/formatRelative/": [
		4015,
		7,
		65922
	],
	"./ru/_lib/formatRelative/index": [
		4015,
		7,
		65922
	],
	"./ru/_lib/formatRelative/index.js": [
		4015,
		7,
		65922
	],
	"./ru/_lib/localize": [
		7170,
		7,
		7170
	],
	"./ru/_lib/localize/": [
		7170,
		7,
		7170
	],
	"./ru/_lib/localize/index": [
		7170,
		7,
		7170
	],
	"./ru/_lib/localize/index.js": [
		7170,
		7,
		7170
	],
	"./ru/_lib/match": [
		405,
		7,
		405
	],
	"./ru/_lib/match/": [
		405,
		7,
		405
	],
	"./ru/_lib/match/index": [
		405,
		7,
		405
	],
	"./ru/_lib/match/index.js": [
		405,
		7,
		405
	],
	"./ru/index": [
		77710,
		7,
		77710
	],
	"./ru/index.d": [
		5601,
		9,
		5601
	],
	"./ru/index.d.ts": [
		5601,
		9,
		5601
	],
	"./ru/index.js": [
		77710,
		7,
		77710
	],
	"./ru/index.js.flow": [
		33007,
		7,
		33007
	],
	"./ru/package": [
		74744,
		3,
		74744
	],
	"./ru/package.json": [
		74744,
		3,
		74744
	],
	"./ru/snapshot.md": [
		27838,
		7,
		27838
	],
	"./sk": [
		75378,
		9,
		33959
	],
	"./sk/": [
		75378,
		9,
		33959
	],
	"./sk/_lib/formatDistance": [
		64187,
		7,
		64187
	],
	"./sk/_lib/formatDistance/": [
		64187,
		7,
		64187
	],
	"./sk/_lib/formatDistance/index": [
		64187,
		7,
		64187
	],
	"./sk/_lib/formatDistance/index.js": [
		64187,
		7,
		64187
	],
	"./sk/_lib/formatLong": [
		11565,
		7,
		11565
	],
	"./sk/_lib/formatLong/": [
		11565,
		7,
		11565
	],
	"./sk/_lib/formatLong/index": [
		11565,
		7,
		11565
	],
	"./sk/_lib/formatLong/index.js": [
		11565,
		7,
		11565
	],
	"./sk/_lib/formatRelative": [
		11809,
		7,
		25581
	],
	"./sk/_lib/formatRelative/": [
		11809,
		7,
		25581
	],
	"./sk/_lib/formatRelative/index": [
		11809,
		7,
		25581
	],
	"./sk/_lib/formatRelative/index.js": [
		11809,
		7,
		25581
	],
	"./sk/_lib/localize": [
		28153,
		7,
		28153
	],
	"./sk/_lib/localize/": [
		28153,
		7,
		28153
	],
	"./sk/_lib/localize/index": [
		28153,
		7,
		28153
	],
	"./sk/_lib/localize/index.js": [
		28153,
		7,
		28153
	],
	"./sk/_lib/match": [
		53845,
		7,
		53845
	],
	"./sk/_lib/match/": [
		53845,
		7,
		53845
	],
	"./sk/_lib/match/index": [
		53845,
		7,
		53845
	],
	"./sk/_lib/match/index.js": [
		53845,
		7,
		53845
	],
	"./sk/index": [
		13690,
		7,
		13690
	],
	"./sk/index.d": [
		33959,
		9,
		33959
	],
	"./sk/index.d.ts": [
		33959,
		9,
		33959
	],
	"./sk/index.js": [
		13690,
		7,
		13690
	],
	"./sk/index.js.flow": [
		19732,
		7,
		19732
	],
	"./sk/package": [
		54221,
		3,
		54221
	],
	"./sk/package.json": [
		54221,
		3,
		54221
	],
	"./sk/snapshot.md": [
		25157,
		7,
		25157
	],
	"./sl": [
		22664,
		9,
		88663
	],
	"./sl/": [
		22664,
		9,
		88663
	],
	"./sl/_lib/formatDistance": [
		65363,
		7,
		65363
	],
	"./sl/_lib/formatDistance/": [
		65363,
		7,
		65363
	],
	"./sl/_lib/formatDistance/index": [
		65363,
		7,
		65363
	],
	"./sl/_lib/formatDistance/index.js": [
		65363,
		7,
		65363
	],
	"./sl/_lib/formatLong": [
		39874,
		7,
		39874
	],
	"./sl/_lib/formatLong/": [
		39874,
		7,
		39874
	],
	"./sl/_lib/formatLong/index": [
		39874,
		7,
		39874
	],
	"./sl/_lib/formatLong/index.js": [
		39874,
		7,
		39874
	],
	"./sl/_lib/formatRelative": [
		97228,
		7,
		97228
	],
	"./sl/_lib/formatRelative/": [
		97228,
		7,
		97228
	],
	"./sl/_lib/formatRelative/index": [
		97228,
		7,
		97228
	],
	"./sl/_lib/formatRelative/index.js": [
		97228,
		7,
		97228
	],
	"./sl/_lib/localize": [
		4398,
		7,
		4398
	],
	"./sl/_lib/localize/": [
		4398,
		7,
		4398
	],
	"./sl/_lib/localize/index": [
		4398,
		7,
		4398
	],
	"./sl/_lib/localize/index.js": [
		4398,
		7,
		4398
	],
	"./sl/_lib/match": [
		61776,
		7,
		61776
	],
	"./sl/_lib/match/": [
		61776,
		7,
		61776
	],
	"./sl/_lib/match/index": [
		61776,
		7,
		61776
	],
	"./sl/_lib/match/index.js": [
		61776,
		7,
		61776
	],
	"./sl/index": [
		41937,
		7,
		41937
	],
	"./sl/index.d": [
		88663,
		9,
		88663
	],
	"./sl/index.d.ts": [
		88663,
		9,
		88663
	],
	"./sl/index.js": [
		41937,
		7,
		41937
	],
	"./sl/index.js.flow": [
		37413,
		7,
		37413
	],
	"./sl/package": [
		60090,
		3,
		60090
	],
	"./sl/package.json": [
		60090,
		3,
		60090
	],
	"./sl/snapshot.md": [
		12470,
		7,
		12470
	],
	"./sr": [
		78027,
		9,
		96450
	],
	"./sr-Latn": [
		24833,
		9,
		43150
	],
	"./sr-Latn/": [
		24833,
		9,
		43150
	],
	"./sr-Latn/_lib/formatDistance": [
		34704,
		7,
		34704
	],
	"./sr-Latn/_lib/formatDistance/": [
		34704,
		7,
		34704
	],
	"./sr-Latn/_lib/formatDistance/index": [
		34704,
		7,
		34704
	],
	"./sr-Latn/_lib/formatDistance/index.js": [
		34704,
		7,
		34704
	],
	"./sr-Latn/_lib/formatLong": [
		34562,
		7,
		34562
	],
	"./sr-Latn/_lib/formatLong/": [
		34562,
		7,
		34562
	],
	"./sr-Latn/_lib/formatLong/index": [
		34562,
		7,
		34562
	],
	"./sr-Latn/_lib/formatLong/index.js": [
		34562,
		7,
		34562
	],
	"./sr-Latn/_lib/formatRelative": [
		16215,
		7,
		16215
	],
	"./sr-Latn/_lib/formatRelative/": [
		16215,
		7,
		16215
	],
	"./sr-Latn/_lib/formatRelative/index": [
		16215,
		7,
		16215
	],
	"./sr-Latn/_lib/formatRelative/index.js": [
		16215,
		7,
		16215
	],
	"./sr-Latn/_lib/localize": [
		62153,
		7,
		62153
	],
	"./sr-Latn/_lib/localize/": [
		62153,
		7,
		62153
	],
	"./sr-Latn/_lib/localize/index": [
		62153,
		7,
		62153
	],
	"./sr-Latn/_lib/localize/index.js": [
		62153,
		7,
		62153
	],
	"./sr-Latn/_lib/match": [
		23755,
		7,
		23755
	],
	"./sr-Latn/_lib/match/": [
		23755,
		7,
		23755
	],
	"./sr-Latn/_lib/match/index": [
		23755,
		7,
		23755
	],
	"./sr-Latn/_lib/match/index.js": [
		23755,
		7,
		23755
	],
	"./sr-Latn/index": [
		11067,
		7,
		11067
	],
	"./sr-Latn/index.d": [
		43150,
		9,
		43150
	],
	"./sr-Latn/index.d.ts": [
		43150,
		9,
		43150
	],
	"./sr-Latn/index.js": [
		11067,
		7,
		11067
	],
	"./sr-Latn/index.js.flow": [
		89328,
		7,
		89328
	],
	"./sr-Latn/package": [
		92472,
		3,
		92472
	],
	"./sr-Latn/package.json": [
		92472,
		3,
		92472
	],
	"./sr-Latn/snapshot.md": [
		65705,
		7,
		65705
	],
	"./sr/": [
		78027,
		9,
		96450
	],
	"./sr/_lib/formatDistance": [
		92466,
		7,
		92466
	],
	"./sr/_lib/formatDistance/": [
		92466,
		7,
		92466
	],
	"./sr/_lib/formatDistance/index": [
		92466,
		7,
		92466
	],
	"./sr/_lib/formatDistance/index.js": [
		92466,
		7,
		92466
	],
	"./sr/_lib/formatLong": [
		17160,
		7,
		17160
	],
	"./sr/_lib/formatLong/": [
		17160,
		7,
		17160
	],
	"./sr/_lib/formatLong/index": [
		17160,
		7,
		17160
	],
	"./sr/_lib/formatLong/index.js": [
		17160,
		7,
		17160
	],
	"./sr/_lib/formatRelative": [
		46174,
		7,
		46174
	],
	"./sr/_lib/formatRelative/": [
		46174,
		7,
		46174
	],
	"./sr/_lib/formatRelative/index": [
		46174,
		7,
		46174
	],
	"./sr/_lib/formatRelative/index.js": [
		46174,
		7,
		46174
	],
	"./sr/_lib/localize": [
		9605,
		7,
		9605
	],
	"./sr/_lib/localize/": [
		9605,
		7,
		9605
	],
	"./sr/_lib/localize/index": [
		9605,
		7,
		9605
	],
	"./sr/_lib/localize/index.js": [
		9605,
		7,
		9605
	],
	"./sr/_lib/match": [
		60850,
		7,
		60850
	],
	"./sr/_lib/match/": [
		60850,
		7,
		60850
	],
	"./sr/_lib/match/index": [
		60850,
		7,
		60850
	],
	"./sr/_lib/match/index.js": [
		60850,
		7,
		60850
	],
	"./sr/index": [
		77468,
		7,
		77468
	],
	"./sr/index.d": [
		96450,
		9,
		96450
	],
	"./sr/index.d.ts": [
		96450,
		9,
		96450
	],
	"./sr/index.js": [
		77468,
		7,
		77468
	],
	"./sr/index.js.flow": [
		10834,
		7,
		10834
	],
	"./sr/package": [
		19024,
		3,
		19024
	],
	"./sr/package.json": [
		19024,
		3,
		19024
	],
	"./sr/snapshot.md": [
		14412,
		7,
		14412
	],
	"./sv": [
		60309,
		9,
		98563
	],
	"./sv/": [
		60309,
		9,
		98563
	],
	"./sv/_lib/formatDistance": [
		61969,
		7,
		61969
	],
	"./sv/_lib/formatDistance/": [
		61969,
		7,
		61969
	],
	"./sv/_lib/formatDistance/index": [
		61969,
		7,
		61969
	],
	"./sv/_lib/formatDistance/index.js": [
		61969,
		7,
		61969
	],
	"./sv/_lib/formatLong": [
		36823,
		7,
		36823
	],
	"./sv/_lib/formatLong/": [
		36823,
		7,
		36823
	],
	"./sv/_lib/formatLong/index": [
		36823,
		7,
		36823
	],
	"./sv/_lib/formatLong/index.js": [
		36823,
		7,
		36823
	],
	"./sv/_lib/formatRelative": [
		66049,
		7,
		66049
	],
	"./sv/_lib/formatRelative/": [
		66049,
		7,
		66049
	],
	"./sv/_lib/formatRelative/index": [
		66049,
		7,
		66049
	],
	"./sv/_lib/formatRelative/index.js": [
		66049,
		7,
		66049
	],
	"./sv/_lib/localize": [
		32288,
		7,
		32288
	],
	"./sv/_lib/localize/": [
		32288,
		7,
		32288
	],
	"./sv/_lib/localize/index": [
		32288,
		7,
		32288
	],
	"./sv/_lib/localize/index.js": [
		32288,
		7,
		32288
	],
	"./sv/_lib/match": [
		64035,
		7,
		64035
	],
	"./sv/_lib/match/": [
		64035,
		7,
		64035
	],
	"./sv/_lib/match/index": [
		64035,
		7,
		64035
	],
	"./sv/_lib/match/index.js": [
		64035,
		7,
		64035
	],
	"./sv/index": [
		60903,
		7,
		60903
	],
	"./sv/index.d": [
		98563,
		9,
		98563
	],
	"./sv/index.d.ts": [
		98563,
		9,
		98563
	],
	"./sv/index.js": [
		60903,
		7,
		60903
	],
	"./sv/index.js.flow": [
		29855,
		7,
		29855
	],
	"./sv/package": [
		24844,
		3,
		24844
	],
	"./sv/package.json": [
		24844,
		3,
		24844
	],
	"./sv/snapshot.md": [
		35341,
		7,
		35341
	],
	"./ta": [
		485,
		9,
		51735
	],
	"./ta/": [
		485,
		9,
		51735
	],
	"./ta/_lib/formatDistance": [
		64154,
		7,
		64154
	],
	"./ta/_lib/formatDistance/": [
		64154,
		7,
		64154
	],
	"./ta/_lib/formatDistance/index": [
		64154,
		7,
		64154
	],
	"./ta/_lib/formatDistance/index.js": [
		64154,
		7,
		64154
	],
	"./ta/_lib/formatLong": [
		30257,
		7,
		30257
	],
	"./ta/_lib/formatLong/": [
		30257,
		7,
		30257
	],
	"./ta/_lib/formatLong/index": [
		30257,
		7,
		30257
	],
	"./ta/_lib/formatLong/index.js": [
		30257,
		7,
		30257
	],
	"./ta/_lib/formatRelative": [
		5608,
		7,
		5608
	],
	"./ta/_lib/formatRelative/": [
		5608,
		7,
		5608
	],
	"./ta/_lib/formatRelative/index": [
		5608,
		7,
		5608
	],
	"./ta/_lib/formatRelative/index.js": [
		5608,
		7,
		5608
	],
	"./ta/_lib/localize": [
		79041,
		7,
		79041
	],
	"./ta/_lib/localize/": [
		79041,
		7,
		79041
	],
	"./ta/_lib/localize/index": [
		79041,
		7,
		79041
	],
	"./ta/_lib/localize/index.js": [
		79041,
		7,
		79041
	],
	"./ta/_lib/match": [
		71610,
		7,
		71610
	],
	"./ta/_lib/match/": [
		71610,
		7,
		71610
	],
	"./ta/_lib/match/index": [
		71610,
		7,
		71610
	],
	"./ta/_lib/match/index.js": [
		71610,
		7,
		71610
	],
	"./ta/index": [
		73236,
		7,
		73236
	],
	"./ta/index.d": [
		51735,
		9,
		51735
	],
	"./ta/index.d.ts": [
		51735,
		9,
		51735
	],
	"./ta/index.js": [
		73236,
		7,
		73236
	],
	"./ta/index.js.flow": [
		81517,
		7,
		81517
	],
	"./ta/package": [
		12307,
		3,
		12307
	],
	"./ta/package.json": [
		12307,
		3,
		12307
	],
	"./ta/snapshot.md": [
		16983,
		7,
		16983
	],
	"./te": [
		24237,
		9,
		60078
	],
	"./te/": [
		24237,
		9,
		60078
	],
	"./te/_lib/formatDistance": [
		41459,
		7,
		41459
	],
	"./te/_lib/formatDistance/": [
		41459,
		7,
		41459
	],
	"./te/_lib/formatDistance/index": [
		41459,
		7,
		41459
	],
	"./te/_lib/formatDistance/index.js": [
		41459,
		7,
		41459
	],
	"./te/_lib/formatLong": [
		56686,
		7,
		56686
	],
	"./te/_lib/formatLong/": [
		56686,
		7,
		56686
	],
	"./te/_lib/formatLong/index": [
		56686,
		7,
		56686
	],
	"./te/_lib/formatLong/index.js": [
		56686,
		7,
		56686
	],
	"./te/_lib/formatRelative": [
		66027,
		7,
		66027
	],
	"./te/_lib/formatRelative/": [
		66027,
		7,
		66027
	],
	"./te/_lib/formatRelative/index": [
		66027,
		7,
		66027
	],
	"./te/_lib/formatRelative/index.js": [
		66027,
		7,
		66027
	],
	"./te/_lib/localize": [
		48620,
		7,
		48620
	],
	"./te/_lib/localize/": [
		48620,
		7,
		48620
	],
	"./te/_lib/localize/index": [
		48620,
		7,
		48620
	],
	"./te/_lib/localize/index.js": [
		48620,
		7,
		48620
	],
	"./te/_lib/match": [
		67712,
		7,
		67712
	],
	"./te/_lib/match/": [
		67712,
		7,
		67712
	],
	"./te/_lib/match/index": [
		67712,
		7,
		67712
	],
	"./te/_lib/match/index.js": [
		67712,
		7,
		67712
	],
	"./te/index": [
		76104,
		7,
		76104
	],
	"./te/index.d": [
		60078,
		9,
		60078
	],
	"./te/index.d.ts": [
		60078,
		9,
		60078
	],
	"./te/index.js": [
		76104,
		7,
		76104
	],
	"./te/index.js.flow": [
		99511,
		7,
		99511
	],
	"./te/package": [
		9318,
		3,
		9318
	],
	"./te/package.json": [
		9318,
		3,
		9318
	],
	"./te/snapshot.md": [
		97066,
		7,
		97066
	],
	"./th": [
		85678,
		9,
		83498
	],
	"./th/": [
		85678,
		9,
		83498
	],
	"./th/_lib/formatDistance": [
		16474,
		7,
		16474
	],
	"./th/_lib/formatDistance/": [
		16474,
		7,
		16474
	],
	"./th/_lib/formatDistance/index": [
		16474,
		7,
		16474
	],
	"./th/_lib/formatDistance/index.js": [
		16474,
		7,
		16474
	],
	"./th/_lib/formatLong": [
		64869,
		7,
		64869
	],
	"./th/_lib/formatLong/": [
		64869,
		7,
		64869
	],
	"./th/_lib/formatLong/index": [
		64869,
		7,
		64869
	],
	"./th/_lib/formatLong/index.js": [
		64869,
		7,
		64869
	],
	"./th/_lib/formatRelative": [
		94832,
		7,
		94832
	],
	"./th/_lib/formatRelative/": [
		94832,
		7,
		94832
	],
	"./th/_lib/formatRelative/index": [
		94832,
		7,
		94832
	],
	"./th/_lib/formatRelative/index.js": [
		94832,
		7,
		94832
	],
	"./th/_lib/localize": [
		18551,
		7,
		18551
	],
	"./th/_lib/localize/": [
		18551,
		7,
		18551
	],
	"./th/_lib/localize/index": [
		18551,
		7,
		18551
	],
	"./th/_lib/localize/index.js": [
		18551,
		7,
		18551
	],
	"./th/_lib/match": [
		97430,
		7,
		97430
	],
	"./th/_lib/match/": [
		97430,
		7,
		97430
	],
	"./th/_lib/match/index": [
		97430,
		7,
		97430
	],
	"./th/_lib/match/index.js": [
		97430,
		7,
		97430
	],
	"./th/index": [
		9233,
		7,
		9233
	],
	"./th/index.d": [
		83498,
		9,
		83498
	],
	"./th/index.d.ts": [
		83498,
		9,
		83498
	],
	"./th/index.js": [
		9233,
		7,
		9233
	],
	"./th/index.js.flow": [
		51562,
		7,
		51562
	],
	"./th/package": [
		70752,
		3,
		70752
	],
	"./th/package.json": [
		70752,
		3,
		70752
	],
	"./th/snapshot.md": [
		97043,
		7,
		97043
	],
	"./tr": [
		43173,
		9,
		90171
	],
	"./tr/": [
		43173,
		9,
		90171
	],
	"./tr/_lib/formatDistance": [
		21735,
		7,
		21735
	],
	"./tr/_lib/formatDistance/": [
		21735,
		7,
		21735
	],
	"./tr/_lib/formatDistance/index": [
		21735,
		7,
		21735
	],
	"./tr/_lib/formatDistance/index.js": [
		21735,
		7,
		21735
	],
	"./tr/_lib/formatLong": [
		41673,
		7,
		41673
	],
	"./tr/_lib/formatLong/": [
		41673,
		7,
		41673
	],
	"./tr/_lib/formatLong/index": [
		41673,
		7,
		41673
	],
	"./tr/_lib/formatLong/index.js": [
		41673,
		7,
		41673
	],
	"./tr/_lib/formatRelative": [
		21728,
		7,
		21728
	],
	"./tr/_lib/formatRelative/": [
		21728,
		7,
		21728
	],
	"./tr/_lib/formatRelative/index": [
		21728,
		7,
		21728
	],
	"./tr/_lib/formatRelative/index.js": [
		21728,
		7,
		21728
	],
	"./tr/_lib/localize": [
		57087,
		7,
		57087
	],
	"./tr/_lib/localize/": [
		57087,
		7,
		57087
	],
	"./tr/_lib/localize/index": [
		57087,
		7,
		57087
	],
	"./tr/_lib/localize/index.js": [
		57087,
		7,
		57087
	],
	"./tr/_lib/match": [
		22499,
		7,
		22499
	],
	"./tr/_lib/match/": [
		22499,
		7,
		22499
	],
	"./tr/_lib/match/index": [
		22499,
		7,
		22499
	],
	"./tr/_lib/match/index.js": [
		22499,
		7,
		22499
	],
	"./tr/index": [
		48065,
		7,
		48065
	],
	"./tr/index.d": [
		90171,
		9,
		90171
	],
	"./tr/index.d.ts": [
		90171,
		9,
		90171
	],
	"./tr/index.js": [
		48065,
		7,
		48065
	],
	"./tr/index.js.flow": [
		68500,
		7,
		68500
	],
	"./tr/package": [
		8960,
		3,
		8960
	],
	"./tr/package.json": [
		8960,
		3,
		8960
	],
	"./tr/snapshot.md": [
		43088,
		7,
		43088
	],
	"./ug": [
		20323,
		9,
		12629
	],
	"./ug/": [
		20323,
		9,
		12629
	],
	"./ug/_lib/formatDistance": [
		28061,
		7,
		28061
	],
	"./ug/_lib/formatDistance/": [
		28061,
		7,
		28061
	],
	"./ug/_lib/formatDistance/index": [
		28061,
		7,
		28061
	],
	"./ug/_lib/formatDistance/index.js": [
		28061,
		7,
		28061
	],
	"./ug/_lib/formatLong": [
		25954,
		7,
		25954
	],
	"./ug/_lib/formatLong/": [
		25954,
		7,
		25954
	],
	"./ug/_lib/formatLong/index": [
		25954,
		7,
		25954
	],
	"./ug/_lib/formatLong/index.js": [
		25954,
		7,
		25954
	],
	"./ug/_lib/formatRelative": [
		42782,
		7,
		42782
	],
	"./ug/_lib/formatRelative/": [
		42782,
		7,
		42782
	],
	"./ug/_lib/formatRelative/index": [
		42782,
		7,
		42782
	],
	"./ug/_lib/formatRelative/index.js": [
		42782,
		7,
		42782
	],
	"./ug/_lib/localize": [
		31017,
		7,
		31017
	],
	"./ug/_lib/localize/": [
		31017,
		7,
		31017
	],
	"./ug/_lib/localize/index": [
		31017,
		7,
		31017
	],
	"./ug/_lib/localize/index.js": [
		31017,
		7,
		31017
	],
	"./ug/_lib/match": [
		37183,
		7,
		37183
	],
	"./ug/_lib/match/": [
		37183,
		7,
		37183
	],
	"./ug/_lib/match/index": [
		37183,
		7,
		37183
	],
	"./ug/_lib/match/index.js": [
		37183,
		7,
		37183
	],
	"./ug/index": [
		30529,
		7,
		30529
	],
	"./ug/index.d": [
		12629,
		9,
		12629
	],
	"./ug/index.d.ts": [
		12629,
		9,
		12629
	],
	"./ug/index.js": [
		30529,
		7,
		30529
	],
	"./ug/index.js.flow": [
		43732,
		7,
		43732
	],
	"./ug/package": [
		86900,
		3,
		86900
	],
	"./ug/package.json": [
		86900,
		3,
		86900
	],
	"./ug/snapshot.md": [
		70614,
		7,
		70614
	],
	"./uk": [
		20412,
		9,
		57299
	],
	"./uk/": [
		20412,
		9,
		57299
	],
	"./uk/_lib/formatDistance": [
		84425,
		7,
		84425
	],
	"./uk/_lib/formatDistance/": [
		84425,
		7,
		84425
	],
	"./uk/_lib/formatDistance/index": [
		84425,
		7,
		84425
	],
	"./uk/_lib/formatDistance/index.js": [
		84425,
		7,
		84425
	],
	"./uk/_lib/formatLong": [
		13138,
		7,
		13138
	],
	"./uk/_lib/formatLong/": [
		13138,
		7,
		13138
	],
	"./uk/_lib/formatLong/index": [
		13138,
		7,
		13138
	],
	"./uk/_lib/formatLong/index.js": [
		13138,
		7,
		13138
	],
	"./uk/_lib/formatRelative": [
		46463,
		7,
		25581
	],
	"./uk/_lib/formatRelative/": [
		46463,
		7,
		25581
	],
	"./uk/_lib/formatRelative/index": [
		46463,
		7,
		25581
	],
	"./uk/_lib/formatRelative/index.js": [
		46463,
		7,
		25581
	],
	"./uk/_lib/localize": [
		79113,
		7,
		79113
	],
	"./uk/_lib/localize/": [
		79113,
		7,
		79113
	],
	"./uk/_lib/localize/index": [
		79113,
		7,
		79113
	],
	"./uk/_lib/localize/index.js": [
		79113,
		7,
		79113
	],
	"./uk/_lib/match": [
		21065,
		7,
		21065
	],
	"./uk/_lib/match/": [
		21065,
		7,
		21065
	],
	"./uk/_lib/match/index": [
		21065,
		7,
		21065
	],
	"./uk/_lib/match/index.js": [
		21065,
		7,
		21065
	],
	"./uk/index": [
		27952,
		7,
		27952
	],
	"./uk/index.d": [
		57299,
		9,
		57299
	],
	"./uk/index.d.ts": [
		57299,
		9,
		57299
	],
	"./uk/index.js": [
		27952,
		7,
		27952
	],
	"./uk/index.js.flow": [
		61837,
		7,
		61837
	],
	"./uk/package": [
		79079,
		3,
		79079
	],
	"./uk/package.json": [
		79079,
		3,
		79079
	],
	"./uk/snapshot.md": [
		25676,
		7,
		25676
	],
	"./uz": [
		20935,
		9,
		28093
	],
	"./uz/": [
		20935,
		9,
		28093
	],
	"./uz/_lib/formatDistance": [
		21919,
		7,
		21919
	],
	"./uz/_lib/formatDistance/": [
		21919,
		7,
		21919
	],
	"./uz/_lib/formatDistance/index": [
		21919,
		7,
		21919
	],
	"./uz/_lib/formatDistance/index.js": [
		21919,
		7,
		21919
	],
	"./uz/_lib/formatLong": [
		50178,
		7,
		50178
	],
	"./uz/_lib/formatLong/": [
		50178,
		7,
		50178
	],
	"./uz/_lib/formatLong/index": [
		50178,
		7,
		50178
	],
	"./uz/_lib/formatLong/index.js": [
		50178,
		7,
		50178
	],
	"./uz/_lib/formatRelative": [
		27189,
		7,
		27189
	],
	"./uz/_lib/formatRelative/": [
		27189,
		7,
		27189
	],
	"./uz/_lib/formatRelative/index": [
		27189,
		7,
		27189
	],
	"./uz/_lib/formatRelative/index.js": [
		27189,
		7,
		27189
	],
	"./uz/_lib/localize": [
		21057,
		7,
		21057
	],
	"./uz/_lib/localize/": [
		21057,
		7,
		21057
	],
	"./uz/_lib/localize/index": [
		21057,
		7,
		21057
	],
	"./uz/_lib/localize/index.js": [
		21057,
		7,
		21057
	],
	"./uz/_lib/match": [
		53386,
		7,
		3406
	],
	"./uz/_lib/match/": [
		53386,
		7,
		3406
	],
	"./uz/_lib/match/index": [
		53386,
		7,
		3406
	],
	"./uz/_lib/match/index.js": [
		53386,
		7,
		3406
	],
	"./uz/index": [
		34017,
		7,
		34017
	],
	"./uz/index.d": [
		28093,
		9,
		28093
	],
	"./uz/index.d.ts": [
		28093,
		9,
		28093
	],
	"./uz/index.js": [
		34017,
		7,
		34017
	],
	"./uz/index.js.flow": [
		54233,
		7,
		54233
	],
	"./uz/package": [
		42567,
		3,
		42567
	],
	"./uz/package.json": [
		42567,
		3,
		42567
	],
	"./uz/snapshot.md": [
		57406,
		7,
		57406
	],
	"./vi": [
		13169,
		9,
		70472
	],
	"./vi/": [
		13169,
		9,
		70472
	],
	"./vi/_lib/formatDistance": [
		17810,
		7,
		17810
	],
	"./vi/_lib/formatDistance/": [
		17810,
		7,
		17810
	],
	"./vi/_lib/formatDistance/index": [
		17810,
		7,
		17810
	],
	"./vi/_lib/formatDistance/index.js": [
		17810,
		7,
		17810
	],
	"./vi/_lib/formatLong": [
		75427,
		7,
		75427
	],
	"./vi/_lib/formatLong/": [
		75427,
		7,
		75427
	],
	"./vi/_lib/formatLong/index": [
		75427,
		7,
		75427
	],
	"./vi/_lib/formatLong/index.js": [
		75427,
		7,
		75427
	],
	"./vi/_lib/formatRelative": [
		78945,
		7,
		78945
	],
	"./vi/_lib/formatRelative/": [
		78945,
		7,
		78945
	],
	"./vi/_lib/formatRelative/index": [
		78945,
		7,
		78945
	],
	"./vi/_lib/formatRelative/index.js": [
		78945,
		7,
		78945
	],
	"./vi/_lib/localize": [
		23526,
		7,
		23526
	],
	"./vi/_lib/localize/": [
		23526,
		7,
		23526
	],
	"./vi/_lib/localize/index": [
		23526,
		7,
		23526
	],
	"./vi/_lib/localize/index.js": [
		23526,
		7,
		23526
	],
	"./vi/_lib/match": [
		44610,
		7,
		44610
	],
	"./vi/_lib/match/": [
		44610,
		7,
		44610
	],
	"./vi/_lib/match/index": [
		44610,
		7,
		44610
	],
	"./vi/_lib/match/index.js": [
		44610,
		7,
		44610
	],
	"./vi/index": [
		33839,
		7,
		33839
	],
	"./vi/index.d": [
		70472,
		9,
		70472
	],
	"./vi/index.d.ts": [
		70472,
		9,
		70472
	],
	"./vi/index.js": [
		33839,
		7,
		33839
	],
	"./vi/index.js.flow": [
		24064,
		7,
		24064
	],
	"./vi/package": [
		70403,
		3,
		70403
	],
	"./vi/package.json": [
		70403,
		3,
		70403
	],
	"./vi/snapshot.md": [
		5411,
		7,
		5411
	],
	"./zh-CN": [
		90413,
		9,
		52524
	],
	"./zh-CN/": [
		90413,
		9,
		52524
	],
	"./zh-CN/_lib/formatDistance": [
		64814,
		7,
		64814
	],
	"./zh-CN/_lib/formatDistance/": [
		64814,
		7,
		64814
	],
	"./zh-CN/_lib/formatDistance/index": [
		64814,
		7,
		64814
	],
	"./zh-CN/_lib/formatDistance/index.js": [
		64814,
		7,
		64814
	],
	"./zh-CN/_lib/formatLong": [
		53025,
		7,
		53025
	],
	"./zh-CN/_lib/formatLong/": [
		53025,
		7,
		53025
	],
	"./zh-CN/_lib/formatLong/index": [
		53025,
		7,
		53025
	],
	"./zh-CN/_lib/formatLong/index.js": [
		53025,
		7,
		53025
	],
	"./zh-CN/_lib/formatRelative": [
		22375,
		7,
		65922
	],
	"./zh-CN/_lib/formatRelative/": [
		22375,
		7,
		65922
	],
	"./zh-CN/_lib/formatRelative/index": [
		22375,
		7,
		65922
	],
	"./zh-CN/_lib/formatRelative/index.js": [
		22375,
		7,
		65922
	],
	"./zh-CN/_lib/localize": [
		45362,
		7,
		45362
	],
	"./zh-CN/_lib/localize/": [
		45362,
		7,
		45362
	],
	"./zh-CN/_lib/localize/index": [
		45362,
		7,
		45362
	],
	"./zh-CN/_lib/localize/index.js": [
		45362,
		7,
		45362
	],
	"./zh-CN/_lib/match": [
		83858,
		7,
		83858
	],
	"./zh-CN/_lib/match/": [
		83858,
		7,
		83858
	],
	"./zh-CN/_lib/match/index": [
		83858,
		7,
		83858
	],
	"./zh-CN/_lib/match/index.js": [
		83858,
		7,
		83858
	],
	"./zh-CN/index": [
		27629,
		7,
		27629
	],
	"./zh-CN/index.d": [
		52524,
		9,
		52524
	],
	"./zh-CN/index.d.ts": [
		52524,
		9,
		52524
	],
	"./zh-CN/index.js": [
		27629,
		7,
		27629
	],
	"./zh-CN/index.js.flow": [
		67255,
		7,
		67255
	],
	"./zh-CN/package": [
		69607,
		3,
		69607
	],
	"./zh-CN/package.json": [
		69607,
		3,
		69607
	],
	"./zh-CN/snapshot.md": [
		51353,
		7,
		51353
	],
	"./zh-TW": [
		76162,
		9,
		10966
	],
	"./zh-TW/": [
		76162,
		9,
		10966
	],
	"./zh-TW/_lib/formatDistance": [
		53913,
		7,
		53913
	],
	"./zh-TW/_lib/formatDistance/": [
		53913,
		7,
		53913
	],
	"./zh-TW/_lib/formatDistance/index": [
		53913,
		7,
		53913
	],
	"./zh-TW/_lib/formatDistance/index.js": [
		53913,
		7,
		53913
	],
	"./zh-TW/_lib/formatLong": [
		58605,
		7,
		58605
	],
	"./zh-TW/_lib/formatLong/": [
		58605,
		7,
		58605
	],
	"./zh-TW/_lib/formatLong/index": [
		58605,
		7,
		58605
	],
	"./zh-TW/_lib/formatLong/index.js": [
		58605,
		7,
		58605
	],
	"./zh-TW/_lib/formatRelative": [
		17382,
		7,
		17382
	],
	"./zh-TW/_lib/formatRelative/": [
		17382,
		7,
		17382
	],
	"./zh-TW/_lib/formatRelative/index": [
		17382,
		7,
		17382
	],
	"./zh-TW/_lib/formatRelative/index.js": [
		17382,
		7,
		17382
	],
	"./zh-TW/_lib/localize": [
		14257,
		7,
		14257
	],
	"./zh-TW/_lib/localize/": [
		14257,
		7,
		14257
	],
	"./zh-TW/_lib/localize/index": [
		14257,
		7,
		14257
	],
	"./zh-TW/_lib/localize/index.js": [
		14257,
		7,
		14257
	],
	"./zh-TW/_lib/match": [
		7740,
		7,
		7740
	],
	"./zh-TW/_lib/match/": [
		7740,
		7,
		7740
	],
	"./zh-TW/_lib/match/index": [
		7740,
		7,
		7740
	],
	"./zh-TW/_lib/match/index.js": [
		7740,
		7,
		7740
	],
	"./zh-TW/index": [
		96314,
		7,
		96314
	],
	"./zh-TW/index.d": [
		10966,
		9,
		10966
	],
	"./zh-TW/index.d.ts": [
		10966,
		9,
		10966
	],
	"./zh-TW/index.js": [
		96314,
		7,
		96314
	],
	"./zh-TW/index.js.flow": [
		41781,
		7,
		41781
	],
	"./zh-TW/package": [
		86478,
		3,
		86478
	],
	"./zh-TW/package.json": [
		86478,
		3,
		86478
	],
	"./zh-TW/snapshot.md": [
		72520,
		7,
		72520
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 99937;
module.exports = webpackAsyncContext;